
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, firstValueFrom, map } from "rxjs";
import { EncrdecrService } from './../Auth/encrdecr.service';
import { ConvertToJSONService } from '../services/convert-to-json.service';
import * as FileSaver from 'file-saver';

const headers = { headers: new HttpHeaders({ 'content-type': 'application/json' }) }

@Injectable({
  providedIn: 'root'
})
export class ReportService {

  SetSelectedMenu: string;
  SetSelectedTab: string;
  ExchangeFlag: number;
  CompanyType: number;
  ServerUrl = environment.ServerUrl;

  constructor(private http: HttpClient,
    private EncrdecrService: EncrdecrService,
    private ConvertToJSON: ConvertToJSONService) {


  }

  GetProductAndCatDropdown(Status, ProductId): Observable<any> {
    debugger
    let url = `${this.ServerUrl}/api/CoBranding/Details`;
    const QueryString = `Status=${Status}&ProductId=${ProductId}`;
    const body = this.ConvertToJSON.QueryStringToJSON(QueryString);
    let request = { data: this.EncrdecrService.setEncr(JSON.stringify(body)) }
    return this.http.post<any>(url, request, this.GetToken());
  }
  BindType(Status): Observable<any> {
    let url = `${this.ServerUrl}/api/CoBranding/CoBranding_ValueAddTemplateDetails`;
    const QueryString = `Status=${Status}`;
    const body = this.ConvertToJSON.QueryStringToJSON(QueryString);
    let request = { data: this.EncrdecrService.setEncr(JSON.stringify(body)) }
    return this.http.post<any>(url, request, this.GetToken());
  }
  BindValueAddServiceData(Status, productid, CategoryName, FileTypewith, SUB_BROKER_CODE): Observable<any> {
    let url = `${this.ServerUrl}/api/CoBranding/CoBranding_ValueAddTemplateDetails`;
    const QueryString = `Status=${Status}&productid=${productid}&CategoryName=${CategoryName}&FileTypewith=${FileTypewith}&FileTypewith=${FileTypewith}&SUB_BROKER_CODE=${SUB_BROKER_CODE}`;
    const body = this.ConvertToJSON.QueryStringToJSON(QueryString);
    let request = { data: this.EncrdecrService.setEncr(JSON.stringify(body)) }
    return this.http.post<any>(url, request, this.GetToken());
  }

  //added by disha
  sendReportMail(baseString, ClientId, ReportName, AsOnDate, flag_report, email): Observable<any> {
    debugger
    const url = `${this.ServerUrl}/api/CommonOTP/SendEmail`;
    // const token = this.GetToken();
    const request =
    {
      Base64String: baseString,
      ClientBasicinfoId: ClientId,
      SchemeName: ReportName,
      createDate: AsOnDate,
      Flag: flag_report,
      EmailId: email
    }
    console.log(request)
    console.log(baseString);
    return this.http.post<any>(url, request).pipe();
  }

  //Added by Dalsukh 29-10-2024
  sendReportMail_New(baseString, ReportName, AsOnDate, email, FromDate, ToDate, TemplateName, Client_Name, Flag, DateFLag, PANNo): Observable<any> {

    debugger
    const url = `${this.ServerUrl}/api/CommonOTP/SendEmail_New`;
    //const url =  "http://localhost:2021//api/CommonOTP/SendEmail_New";
    // const token = this.GetToken();
    const request =
    {
      Base64String: baseString,
      ReportName: ReportName,
      AsOnDate: AsOnDate,
      FromDate: FromDate,
      ToDate: ToDate,
      EmailId: email,
      TemplateName: TemplateName,
      CLIENT_NAME: Client_Name,
      Flag: Flag,
      DateFLag: DateFLag,
      PAN: PANNo
    }
    console.log("re", request)
    return this.http.post<any>(url, request);
  }

  CoBranding_GenerateLogo(BrandingWithoutEDL, ValueAddID, DownloadSource, SUB_BROKER_CODE, LogoChk, DetailChk, EMP_ID): Observable<any> {
    let url = `${this.ServerUrl}/api/CoBranding/CoBranding_GenerateLogo`;
    const QueryString = `BrandingWithoutEDL=${BrandingWithoutEDL}&ValueAddID=${ValueAddID}&DownloadSource=${DownloadSource}&SUB_BROKER_CODE=${SUB_BROKER_CODE}&LogoChk=${LogoChk}&DetailChk=${DetailChk}&EMP_ID=${EMP_ID}`;
    const body = this.ConvertToJSON.QueryStringToJSON(QueryString);
    let request = { data: this.EncrdecrService.setEncr(JSON.stringify(body)) }
    return this.http.post<any>(url, request, this.GetToken());
  }

  //Added by Tishya 
  CoBranding_GenerateLogoUsingFDImage(BrandingWithoutEDL, ValueAddID, DownloadSource, SUB_BROKER_CODE, LogoChk, DetailChk, EMP_ID, CobrandingImage): Observable<any> {
    let url = `${this.ServerUrl}/api/CoBranding/CoBranding_GenerateLogo`;
    const QueryString = `BrandingWithoutEDL=${BrandingWithoutEDL}&ValueAddID=${ValueAddID}&DownloadSource=${DownloadSource}&SUB_BROKER_CODE=${SUB_BROKER_CODE}&LogoChk=${LogoChk}&DetailChk=${DetailChk}&EMP_ID=${EMP_ID}&BrandingBase64Data=${CobrandingImage}`;
    const body = this.ConvertToJSON.QueryStringToJSON(QueryString);
    let request = { data: this.EncrdecrService.setEncr(JSON.stringify(body)) }
    return this.http.post<any>(url, request, this.GetToken());
  }

  CoBranding_GenerateLogoInByte(BrandingWithEDL): Observable<any> {
    let url = `${this.ServerUrl}/api/CoBranding/CoBranding_GenerateLogoInByte`;
    const QueryString = `BrandingWithEDL=${BrandingWithEDL}`;
    const body = this.ConvertToJSON.QueryStringToJSON(QueryString);
    let request = { data: this.EncrdecrService.setEncr(JSON.stringify(body)) }
    return this.http.post<any>(url, request, this.GetToken());
  }
  //----------------common for all
  GetAllClient(UserType, SubBrokerId): Observable<any> {

    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(sessionStorage.getItem('m5JkoXISmYRAIuY'));
    let User_Type = this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'));
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(token + "@" + UserId + "|" + User_Type + "|" + IpAddress);
    const tokenOption = {
      headers:
        new HttpHeaders(
          {
            'Content-Type': 'application/json',
            'Authorization': `Basic ${TOKEN}`,
          })
    }
    const url = `${this.ServerUrl}/api/ReportFilter/ReportDetails`;
    const QueryString = `TRANS_TYPE=${this.EncrdecrService.setEncr('USERCODE_WISE_CLIENT')}&LOGIN_ID=${this.EncrdecrService.setEncr('0')}&USER_TYPE=${this.EncrdecrService.setEncr(UserType)}&ZONE_ID=0&REGION_ID=0&BRANCH_ID=0&SB_ID=${this.EncrdecrService.setEncr(SubBrokerId)}&EMP_ID=0&FAMILY_ID=0&CLIENT_ID=0`;
    const body = this.ConvertToJSON.QueryStringToJSON(QueryString);
    let djsd = JSON.stringify(body);
    return this.http.post<any>(url, body, tokenOption).pipe();
  }
  //Used in NatureWise Report
  Get_DropDownDetailsNature(TRANS_TYPE) {
    //console.log("Nature::" + `${this.ServerUrl}/api/DropDown/Details?TRANS_TYPE=${TRANS_TYPE}&CON_STR=MF`);
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(sessionStorage.getItem('m5JkoXISmYRAIuY'));
    let User_Type = this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'));
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(token + "@" + UserId + "|" + User_Type + "|" + IpAddress);
    // const tokenOption = {
    //   headers:
    //     new HttpHeaders(
    //       {
    //         'Content-Type': 'application/json',
    //         'Authorization': `Basic ${TOKEN}`,
    //       })
    // }
    const url = `${this.ServerUrl}/api/DropDown/ReportDetails`
    const QueryString = `TRANS_TYPE=${TRANS_TYPE}&CON_STR=MF`;
    // const body = this.ConvertToJSON.QueryStringToJSON(QueryString);
    const tokenOption = this.GetToken();
    const body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(QueryString);
    return this.http.post<any>(url, body, tokenOption).pipe();
    // return this.http.post<any>(url, body, tokenOption).pipe();
  }
  //Used in AMCSchemeWise Report
  Get_DropDownDetails(sbid, Flag) {
    //
    let url = `${this.ServerUrl}/api/DropDown/ReportDetails?TRANS_TYPE=${Flag}&CON_STR=MF&REFF_ID=${sbid}`
    const tokenOption = this.GetToken();
    // const QueryString = this.ConvertToJSON.QueryStringToJSON(url.split('?')[1]);
    url = url.split('?')[0];
    const QueryString = url.split('?')[1];
    const body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(QueryString);
    return this.http.post<any>(url, body, tokenOption).pipe();
    // const token = this.GetToken();
    // //return this.http.get<any>(url).pipe();
    // return this.http.post<any>(url, body, token).pipe();
  }
  //Used in AMCSchemeWise Report
  Get_SchemeName_AMCSchemeWise(sbid, AmcCode, Flag) {
    let url = `${this.ServerUrl}/api/DropDown/ReportDetails?TRANS_TYPE=${Flag}&CON_STR=MF&REFF_ID=${sbid}&REFF_ID2=${AmcCode}`;
    // const body = this.ConvertToJSON.QueryStringToJSON(url.split('?')[1]);
    url = url.split('?')[0];
    const tokenOption = this.GetToken();
    const QueryString = url.split('?')[1];
    const body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(QueryString);
    return this.http.post<any>(url, body, tokenOption).pipe();
    // const token = this.GetToken();
    // return this.http.post<any>(url, body, token).pipe();
  }
  //Used in Allocation Report
  Get_SchemeName_AmcCodeWise(AmcCode) {
    const s_url = `${this.ServerUrl}/api/DropDown/ReportDetails?TRANS_TYPE=SchemeList&CON_STR=MF&REFF_ID=${AmcCode}&REFF_ID2=Equity`;
    // const tokenOption = this.GetToken();
    const url = s_url.split('?')[0];
    // const QueryString = s_url.split('?')[1];
    // const body = this.ConvertToJSON.QueryStringToJSON(QueryString);
    const tokenOption = this.GetToken();
    const QueryString = url.split('?')[1];
    const body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(QueryString);
    return this.http.post<any>(url, body, tokenOption).pipe();
    // return this.http.post<any>(url, body, tokenOption).pipe();

  }
  //used in Return Summary and Return Detail Report
  GetAssetType() {
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(sessionStorage.getItem('m5JkoXISmYRAIuY'));
    let User_Type = this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'));
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(token + "@" + UserId + "|" + User_Type + "|" + IpAddress);
    // const tokenOption = {
    //   headers:
    //     new HttpHeaders(
    //       {
    //         'Content-Type': 'application/json',
    //         'Authorization': `Basic ${TOKEN}`,
    //       })
    // }
    console.log("get Asset Type " + `${this.ServerUrl}/api/DropDown/ReportDetails?TRANS_TYPE=ASSET_TYPE&CON_STR=MF`);
    let url = `${this.ServerUrl}/api/DropDown/ReportDetails?TRANS_TYPE=ASSET_TYPE&CON_STR=MF`;
    // let body = this.ConvertToJSON.QueryStringToJSON(url.split('?')[1])
    const tokenOption = this.GetToken();
    const QueryString = url.split('?')[1];
    const body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(QueryString);
    return this.http.post<any>(url, body, tokenOption).pipe();
    // return this.http.post<any>(url.split('?')[0], body, tokenOption);
  }

  //#region added for family
  Get_AllFamilyGroupDetails(UserType, LoginUserId) {
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(sessionStorage.getItem('m5JkoXISmYRAIuY'));
    let User_Type = this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'));
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(token + "@" + UserId + "|" + User_Type + "|" + IpAddress);
    const tokenOption = {
      headers:
        new HttpHeaders(
          {
            'Content-Type': 'application/json',
            'Authorization': `Basic ${TOKEN}`,
          })
    }
    let url: string;
    let QueryString = "";
    if (UserType == "3") {
      url = `${this.ServerUrl}/api/ClientFamilyGroup/GetFamilyList`;
      // QueryString = `PrefixText=&LoginUserId=${LoginUserId}&TRANS_TYPE=EMPLOYEE`;
      QueryString = `PrefixText=&LoginUserId=${this.EncrdecrService.setEncr(LoginUserId)}&TRANS_TYPE=Client`;
    }
    else if (UserType == "1") {
      url = `${this.ServerUrl}/api/ClientFamilyGroup/GetFamilyList`;
      QueryString = `PrefixText=&LoginUserId=${this.EncrdecrService.setEncr(LoginUserId)}&TRANS_TYPE=EMPLOYEE`;
    }
    else {
      url = `${this.ServerUrl}/api/ClientFamilyGroup/GetFamilyList`;
      QueryString = `PrefixText=&LoginUserId=${this.EncrdecrService.setEncr(LoginUserId)}&TRANS_TYPE=SUBBROKER`;
    }
    //console.log(url)
    const body = this.ConvertToJSON.QueryStringToJSON(QueryString);
    return this.http.post<any>(url, body, tokenOption);
  }
  Get_SelectedFamilyGroupDetails(REFF_ID) {
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(sessionStorage.getItem('m5JkoXISmYRAIuY'));
    let User_Type = this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'));
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(token + "@" + UserId + "|" + User_Type + "|" + IpAddress);
    const tokenOption = {
      headers:
        new HttpHeaders(
          {
            'Content-Type': 'application/json',
            'Authorization': `Basic ${TOKEN}`,
          })

    }
    const url = `${this.ServerUrl}/api/ClientFamilyGroup/ClientFamilyGroupDetails`;
    const QueryString = `TRANS_TYPE=&REFF_ID=${REFF_ID}`;
    const body = this.ConvertToJSON.QueryStringToJSON(QueryString);
    return this.http.post<any>(url, body, tokenOption);
  }
  //#endregion

  //-------------------------------

  //=================SIP Reports=================
  // FromDate, EndDate, UserType,
  GetActiveSIPReport(formData): Observable<any> {
    //////////
    let url = `${this.ServerUrl}/api/ActiveSIPReport/Details`;
    // ?TRANS_TYPE=CLIENT_ID&FromDate=${FromDate}&EndDate=${EndDate}&UserType=${UserType}
    console.log(url);
    // const header = this.GetToken();
    const tokenOption = this.GetToken();
    const body = { data: this.EncrdecrService.setEncr(formData) };
    return this.http.post<any>(url, body, tokenOption).pipe();

    // return this.http.post<any>(url, formData, header);
  }
  GetSTPReportReport(formData: any): Observable<any> {
    //////////
    let url = `${this.ServerUrl}/api/STPReport/Details`;
    // ?TRANS_TYPE=CLIENT_ID&FromDate=${FromDate}&EndDate=${EndDate}&UserType=${UserType}&ClientBasicInfoIdList=${ClientId}&EmployeeCode=${EmployeeId}
    console.log(url);
    console.log(formData)
    const tokenOption = this.GetToken();
    const body = { data: this.EncrdecrService.setEncr(formData) };
    return this.http.post<any>(url, body, tokenOption).pipe();

    // return this.http.post<any>(url, formData, header);
  }

  GetMonthList() {
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(sessionStorage.getItem('m5JkoXISmYRAIuY'));
    let User_Type = this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'));
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(token + "@" + UserId + "|" + User_Type + "|" + IpAddress);
    const tokenOption = {
      headers:
        new HttpHeaders(
          {
            'Content-Type': 'application/json',
            'Authorization': `Basic ${TOKEN}`,
          })

    }
    let s_url = environment.ServerUrl + `/api/DropDownNSE/Details?TRANS_TYPE=MonthList`;
    const url = s_url.split('?')[0];
    const QueryString = s_url.split('?')[1];
    const body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(QueryString);
    return this.http.post<any>(url, body, tokenOption);
  }

  GetYearList() {
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(sessionStorage.getItem('m5JkoXISmYRAIuY'));
    let User_Type = this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'));
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(token + "@" + UserId + "|" + User_Type + "|" + IpAddress);
    const tokenOption = {
      headers:
        new HttpHeaders(
          {
            'Content-Type': 'application/json',
            'Authorization': `Basic ${TOKEN}`,
          })

    }
    let s_url = environment.ServerUrl + `/api/DropDownNSE/Details?TRANS_TYPE=YearList`;
    const url = s_url.split('?')[0];
    const QueryString = s_url.split('?')[1];
    const body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(QueryString);
    return this.http.post<any>(url, body, tokenOption);
  }


  GetFinancialYear() {

    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(sessionStorage.getItem('m5JkoXISmYRAIuY'));
    let User_Type = this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'));
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(token + "@" + UserId + "|" + User_Type + "|" + IpAddress);
    const tokenOption = {
      headers:
        new HttpHeaders(
          {
            'Content-Type': 'application/json',
            'Authorization': `Basic ${TOKEN}`,
          })

    }
    let s_url = environment.ServerUrl + `/api/DropDownNSE/Details?TRANS_TYPE=FinancialYears`;
    const url = s_url.split('?')[0];
    const QueryString = s_url.split('?')[1];
    const body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(QueryString);
    return this.http.post<any>(url, body, tokenOption).pipe();
  }


  GetMonthlySIPReport(data: any) {
    let s_url = environment.ServerUrl + `/api/MonthlySipCollectionReport/GetMonthlySipCollecton`;
    const tokenOption = this.GetToken();
    return this.http.post<any>(s_url, data, tokenOption).pipe();
  }

  GetRedemptionReport(data: any) {
    let s_url = environment.ServerUrl + `/api/RedemptionDetails/GetRedemptionReport`;
    const tokenOption = this.GetToken();
    let req_str = JSON.stringify(data);
    const body = { data: this.EncrdecrService.setEncr(req_str) };
    return this.http.post<any>(s_url, body, tokenOption).pipe();

    // return this.http.post<any>(s_url, data, tokenOption).pipe();
  }

  GetClientFDProfileReport(data: any) {
    let url = environment.ServerUrl + `/api/ClientFDPortFolioDetails/GetClientFDPortFolioDetails`;
    const tokenOption = this.GetToken();
    const body = { data: this.EncrdecrService.setEncr(data) };
    return this.http.post<any>(url, body, tokenOption).pipe();

    // return this.http.post<any>(s_url, data, tokenOption).pipe();
  }

  //added by disha
  GetClientFDBeforeMaturityReport(data: any) {
    debugger;
    // let url =
    //   environment.ServerUrl +
    //   `/api/ClientFDBeforeMaturity/GetClientFDBeforeMaturityReport`;
    // const tokenOption = this.GetToken();
    // const body = { data: this.EncrdecrService.setEncr(data) };
    // return this.http.post<any>(url, body, tokenOption).pipe();

    // return this.http.post<any>(s_url, data, tokenOption).pipe();

    const tokenOption = this.GetToken();
    const url =`${this.ServerUrl}/api/ClientFDBeforeMaturity/GetClientFDBeforeMaturityReport`;

    const body = { data: this.EncrdecrService.setEncr(data) };

    // return this.http.post<any>(url, {}, this.GetToken()).pipe();
    return this.http.post(url, body, {
      ...tokenOption,
      responseType: 'blob' as 'json'
    });

  }

  GetAifCommitmentReport(data: any) {
    let s_url = environment.ServerUrl + `/api/GetAifCommitmentReport/GetRedemptionReport`;
    const tokenOption = this.GetToken();
    return this.http.post<any>(s_url, data, tokenOption).pipe();
  }

  GetFreshSipAdditionReport(data: any) {
    let s_url = environment.ServerUrl + `/api/FreshSipAdditionReport/GetFreshSipAdditionReport`;
    const tokenOption = this.GetToken();
    let req_str = JSON.stringify(data);
    const body = { data: this.EncrdecrService.setEncr(req_str) };
    return this.http.post<any>(s_url, body, tokenOption).pipe();

    // return this.http.post<any>(s_url, data, tokenOption).pipe();
  }

  GetMFMobilizationReport(data: any) {
    let s_url = environment.ServerUrl + `/api/MFMobilization/GetMFMobilizationReport`;
    const tokenOption = this.GetToken();
    let req_str = JSON.stringify(data);
    const body = { data: this.EncrdecrService.setEncr(req_str) };
    return this.http.post<any>(s_url, body, tokenOption).pipe();
    // return this.http.post<any>(s_url, data, tokenOption).pipe();
  }

  GetReversalReport(data: any) {
    let s_url = environment.ServerUrl + `/api/ReversalReport/GetReversalReport`;
    const tokenOption = this.GetToken();
    let req_str = JSON.stringify(data);
    const body = { data: this.EncrdecrService.setEncr(req_str) };
    return this.http.post<any>(s_url, body, tokenOption).pipe();
    // return this.http.post<any>(s_url, data, tokenOption).pipe();
  }

  GetSpBondAndUnlstedReport(data: any) {
    let s_url = environment.ServerUrl + `/api/SpBondAndUnlistedReport/GetSpBondAndUnlistedReport`;
    const tokenOption = this.GetToken();
    return this.http.post<any>(s_url, data, tokenOption).pipe();
  }


  GetFDMaturityReport(data: any) {
    let s_url = environment.ServerUrl + `/api/FDMaturityReport/GetFDMaturityReport`;
    const tokenOption = this.GetToken();
    return this.http.post<any>(s_url, data, tokenOption).pipe();
  }

  GetSPBondEntryReport(data: any) {
    let s_url = environment.ServerUrl + `/api/SPBondEntryReport/GetSPBondEntryReport`;
    const tokenOption = this.GetToken();
    return this.http.post<any>(s_url, data, tokenOption).pipe();
  }

  GetFDMobilizationReport(data: any) {
    let s_url = environment.ServerUrl + `/api/FDMobilizationReport/GetFDMobilizationReport`;
    const tokenOption = this.GetToken();
    return this.http.post<any>(s_url, data, tokenOption).pipe();
  }


  GetExportToExcelData(Info: any, fileName: string) {
    // let parsedDate = moment(new Date().toLocaleDateString(), "MM/DD/YYYY");
    // let outputDate = parsedDate.format("DD-MM-YYYY");
    // import("xlsx").then(xlsx => {
    //   const worksheet = xlsx.utils.json_to_sheet(Info);
    //   const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    //   const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
    //   this.saveAsExcelFile(excelBuffer, fileName+'_'+outputDate);
    // });
  }

  saveAsExcelFile(buffer: any, fileName: string) {
    let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    let EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + EXCEL_EXTENSION);
  }

  GetBounceSIPReport(FromDate, EndDate, UserType, formData): Observable<any> {

    let url = `${this.ServerUrl}/api/SIPBounce/Details?TRANS_TYPE=CLIENT_ID&FromDate=${FromDate}&EndDate=${EndDate}&UserType=${UserType}`;
    const header = this.GetToken();
    console.log("Bounce SIP Data")
    console.log(url)
    console.log(formData)
    return this.http.post<any>(url, formData, header);
  }
  GetMaturedSIPReport(formData): Observable<any> {
    // FromDate, EndDate, UserType, LoginId,
    let url = `${this.ServerUrl}/api/SIPEndDate/Details`;
    // ?TRANS_TYPE=CLIENT_ID&FromDate=${FromDate}&EndDate=${EndDate}&UserType=${UserType}&LOGIN_ID=${LoginId}
    //console.log(url)
    // const header = this.GetToken();
    // return this.http.post<any>(url, formData, header);
    const tokenOption = this.GetToken();
    console.log(url)
    console.log(formData)
    const body = { data: this.EncrdecrService.setEncr(formData) };
    return this.http.post<any>(url, body, tokenOption).pipe();
  }
  GetTerminatedSIPReport(FromDate, EndDate, UserType, LoginId, formData): Observable<any> {
    let url = `${this.ServerUrl}/api/SIPTermination/Details?TRANS_TYPE=CLIENT_ID&FromDate=${FromDate}&EndDate=${EndDate}&UserType=${UserType}&LOGIN_ID=${LoginId}`;
    //console.log(url)
    const header = this.GetToken();
    console.log(url)
    console.log(formData)
    return this.http.post<any>(url, formData, header);
  }
  GetRegisteredSIPReport(FromDate, EndDate, UserType, LoginId, formData): Observable<any> {
    let url = `${this.ServerUrl}/api/SIPAddition/Details?TRANS_TYPE=CLIENT_ID&FromDate=${FromDate}&EndDate=${EndDate}&UserType=${UserType}&LOGIN_ID=${LoginId}`;
    //console.log(url)
    const header = this.GetToken();
    console.log(url)
    console.log(formData)
    return this.http.post<any>(url, formData, header);
  }
  Get_AMCwiseSIP(SUB_BROKER_CODE) {
    let url = `${this.ServerUrl}/api/AMCWiseSIPDetails/Details?SUB_BROKER_CODE=${SUB_BROKER_CODE}&TRANS_TYPE=ALLClient`;
    //console.log(url)
    return this.http.get<any>(url);
  }

  //=================AUM and Other Reports=================
  Get_AUM_NatureWise2(UserType, NATURE, USER_ID, RoleId, Login_ID): Observable<any> {
    debugger
    let DataUrl = `${this.ServerUrl}/api/AUMWiseReportNew/GetDetails?TRANS_TYPE=Nature_SubNature&USER_TYPE=${UserType}&NATURE=${NATURE}&SubNature=&USER_ID=${USER_ID}&Role_ID=${RoleId}&SubBrokerID=${USER_ID}&LOGIN_ID=${Login_ID}`;
    console.log('Nature wise URL:: ' + DataUrl);
    // return this.http.get<any>(url);
    const tokenOption = this.GetToken();
    const url = DataUrl.split('?')[0];
    const QueryString = DataUrl.split('?')[1];
    const body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(QueryString);
    return this.http.post<any>(url, body, tokenOption).pipe();
  }

  GetAUMReportFundWise(UserType, SchemeCode, AMCCode, USER_ID, formData, RoleId): Observable<any> {
    let DataUrl = `${this.ServerUrl}/api/AUMWiseReportNew/GetDetails?USER_TYPE=${UserType}&TRANS_TYPE=FUND_WISE&SchemeCode=${SchemeCode}&AMCCode=${AMCCode}&USER_ID=${USER_ID}&Role_ID=${RoleId}&SubBrokerID=${USER_ID}`;
    console.log(DataUrl);
    const tokenOption = this.GetToken();
    const url = DataUrl.split('?')[0];
    const QueryString = DataUrl.split('?')[1];
    const body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(QueryString);
    return this.http.post<any>(url, body, tokenOption).pipe();
  }
  // return this.http.get<any>(url);

  Get_AMCwiseAUMreport(SUB_BROKER_CODE) {
    return this.http.get<any>(`${this.ServerUrl}/api/AUMWiseReport/AUMDetails?SUB_BROKER_CODE=${SUB_BROKER_CODE}&TRANS_TYPE=AMC`);
  }

  GetHierarchywiseReport(UserType, Login_ID, formData) {
    let url = `${this.ServerUrl}/api/AUMWiseReport?TRANS_TYPE=SUBBROKER&LOGIN_ID=${Login_ID}&USER_TYPE=${UserType}&TransId=${Login_ID}`
    //console.log(url);
    return this.http.get<any>(url);
  }

  GetOrderBookReport(formData) {
    // let DataUrl = `${this.ServerUrl}/api/OrderBook/OrderBookDetails?UCCCode=${UCCCode}&FromDate=${FromDate}&EndDate=${EndDate}&Flag=${Flag}&Role_ID=${Role_ID}`;
    // console.log("Order book Report URl " + DataUrl);
    const tokenOption = this.GetToken();
    // const url = DataUrl.split('?')[0];
    // const QueryString = DataUrl.split('?')[1];
    // const body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(QueryString);
    // return this.http.post<any>(url, body, tokenOption).pipe();
    // // return this.http.get<any>(url);

    let url = `${this.ServerUrl}/api/OrderBook/OrderBookDetails`;

    const body = { data: this.EncrdecrService.setEncr(formData) };
    // return this.http.post<any>(url, formData, this.GetToken());
    return this.http.post<any>(url, body, tokenOption).pipe();
  }

  // GetFDBondDealEntryBookReport(formData) {
  //   // let DataUrl = `${this.ServerUrl}/api/OrderBook/OrderBookDetails?UCCCode=${UCCCode}&FromDate=${FromDate}&EndDate=${EndDate}&Flag=${Flag}&Role_ID=${Role_ID}`;
  //   // console.log("Order book Report URl " + DataUrl);
  //   const tokenOption = this.GetToken();
  //   // const url = DataUrl.split('?')[0];
  //   // const QueryString = DataUrl.split('?')[1];
  //   // const body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(QueryString);
  //   // return this.http.post<any>(url, body, tokenOption).pipe();
  //   // // return this.http.get<any>(url);

  //   let url = `${this.ServerUrl}/api/FDTransaction/GetFDDealEntryReport`;

  //   const body = { data: this.EncrdecrService.setEncr(formData) };
  //   // return this.http.post<any>(url, formData, this.GetToken());
  //   return this.http.post<any>(url, body, tokenOption).pipe();
  // }

  GetFDBondDealEntryBookReport(
    formData
  ): Observable<any> {

    const tokenOption = this.GetToken();
    const url =`${this.ServerUrl}/api/FDTransaction/GetFDDealEntryReport`;

    const body = { data: this.EncrdecrService.setEncr(formData) };

    // return this.http.post<any>(url, {}, this.GetToken()).pipe();
    return this.http.post(url, body, {
      ...tokenOption,
      responseType: 'blob' as 'json'
    });

  }

  //=================Portfolio Reports=================
  GetAllocationAMCReport(PAN, UserType, LoginId, clientId, Employee, subBrokerId, LoginUserIdCode, RoleId): Observable<any> {
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(sessionStorage.getItem('m5JkoXISmYRAIuY'));
    let User_Type = this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'));
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    console.log('allocation token ' + token + "@" + UserId + "|" + User_Type + "|" + IpAddress);
    const TOKEN = btoa(token + "@" + UserId + "|" + User_Type + "|" + IpAddress);
    const tokenOption = {
      headers:
        new HttpHeaders(
          {
            'Content-Type': 'application/json',
            'Authorization': `Basic ${TOKEN}`,
          })
    }
    Employee = 0;
    if (UserType = 3) {
      subBrokerId = "0"
    }
    RoleId = "1";
    let url = `${this.ServerUrl}/api/ClientAllocationReport`;
    const QueryString = `PANNo=${PAN}&TRANS_TYPE=CLIENTDETAILS_BYPAN&UserType=${UserType}&LOGIN_ID=${LoginId}&ClientBasicInfoId=${clientId}&REFF_ID=AMC&Employee=${Employee}&SubBroker=${subBrokerId}&LogInUserID_Code=${LoginUserIdCode}&Role_ID=${RoleId}`;
    const body = this.ConvertToJSON.QueryStringToJSON(QueryString);
    console.log("Allocation Report")
    console.log(url)
    console.log('Allocation body ' + JSON.stringify(body));
    return this.http.post<any>(url, body, tokenOption);
  }
  GetAllocationAssetReport(PAN, UserType, LoginId, clientId, Employee, subBrokerId, LoginUserIdCode, RoleId): Observable<any> {
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(sessionStorage.getItem('m5JkoXISmYRAIuY'));
    let User_Type = this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'));
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(token + "@" + UserId + "|" + User_Type + "|" + IpAddress);
    const tokenOption = {
      headers:
        new HttpHeaders(
          {
            'Content-Type': 'application/json',
            'Authorization': `Basic ${TOKEN}`,
          })
    }
    Employee = 0;
    if (UserType = 3) {
      subBrokerId = "0"
    }
    let url = `${this.ServerUrl}/api/ClientAllocationReport`;
    const QueryString = `PANNo=${PAN}&TRANS_TYPE=CLIENTDETAILS_BYPAN&UserType=${UserType}&LOGIN_ID=${LoginId}&ClientBasicInfoId=${clientId}&REFF_ID=AssetType&Employee=${Employee}&SubBroker=${subBrokerId}&LogInUserID_Code=${LoginUserIdCode}&Role_ID=${RoleId}`;
    console.log(QueryString);
    const body = this.ConvertToJSON.QueryStringToJSON(QueryString);
    console.log(JSON.stringify(body));
    //console.log('Asset  ' + url);
    return this.http.post<any>(url, body, tokenOption);
  }
  //#region Return Summary
  GetReturnSummaryReport(clientId, Employee, subBrokerId, LoginInUserId, Schemecode, AMCCode, AssetType, AsOnDate, FolioNo): Observable<any> {
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(sessionStorage.getItem('m5JkoXISmYRAIuY'));
    let User_Type = this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'));
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    console.log("tken " + token + "@" + UserId + "|" + User_Type + "|" + IpAddress)
    const TOKEN = btoa(token + "@" + UserId + "|" + User_Type + "|" + IpAddress);
    const tokenOption = {
      headers:
        new HttpHeaders(
          {
            'Content-Type': 'application/json',
            'Authorization': `Basic ${TOKEN}`,
          })
    }
    Employee = 0;
    //let FolioNo = "0";
    let url = `${this.ServerUrl}/api/PortfolioBreakdown`;
    const QueryString = `CON_STR=MF&TRANS_TYPE=Client&ClientBasicInfoId=${clientId}&EMPLOYEE_CODE=${Employee}&SUB_BROKER_CODE=${subBrokerId}&LogInUserID_Code=${LoginInUserId}&SchemeCode=${Schemecode}&AMCCode=${AMCCode}&FolioNumber=${FolioNo}&AssetType=${AssetType}&FromDate=01-01-1901&EndDate=${AsOnDate}`;
    const body = this.ConvertToJSON.QueryStringToJSON(QueryString);
    console.log('Return Summary : ' + url);
    console.log('Return Summary body : ' + JSON.stringify(body));
    return this.http.post<any>(url, body, tokenOption);
  }
  GetReturnSummaryReport_JM(clientId, Employee, subBrokerId, LoginInUserId, Schemecode, AMCCode, AssetType, AsOnDate, FolioNo): Observable<any> {
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(sessionStorage.getItem('m5JkoXISmYRAIuY'));
    let User_Type = this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'));
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    console.log("tken " + token + "@" + UserId + "|" + User_Type + "|" + IpAddress)
    const TOKEN = btoa(token + "@" + UserId + "|" + User_Type + "|" + IpAddress);
    const tokenOption = {
      headers:
        new HttpHeaders(
          {
            'Content-Type': 'application/json',
            'Authorization': `Basic ${TOKEN}`,
          })
    }
    Employee = 0;
    //let FolioNo = "0";
    let url = `${this.ServerUrl}/api/PortfolioBreakdown/Details_JM`;
    const QueryString = `CON_STR=MF&TRANS_TYPE=Client&ClientBasicInfoId=${clientId}&EMPLOYEE_CODE=${Employee}&SUB_BROKER_CODE=${subBrokerId}&LogInUserID_Code=${LoginInUserId}&SchemeCode=${Schemecode}&AMCCode=${AMCCode}&FolioNumber=${FolioNo}&AssetType=${AssetType}&FromDate=01-01-1901&EndDate=${AsOnDate}`;
    const body = this.ConvertToJSON.QueryStringToJSON(QueryString);
    console.log('Return Summary : ' + url);
    console.log('Return Summary body : ' + JSON.stringify(body));
    url = url + '?' + QueryString;
    return this.http.post<any>(url, body, tokenOption);
  }
  GetFreshSIPReport(data): Observable<any> {
    let url = `${this.ServerUrl}/api/FreshSIPReport/Details`;
    const tokenOption = this.GetToken();
    let req_str = JSON.stringify(data);
    const body = { data: this.EncrdecrService.setEncr(req_str) };
    return this.http.post<any>(url, body, tokenOption).pipe();
    // return this.http.post<any>(url, body, this.GetToken());
  }
  GetPortfolioSummaryReport(data): Observable<any> {
    let url = `${this.ServerUrl}/api/PortfolioSummary/Summary`;
    const tokenOption = this.GetToken();
    let req_str = JSON.stringify(data);

    let rid = "";
    if (rid == "" && 
              sessionStorage.getItem('F44sGAGh2xwkpUL') != undefined &&
              sessionStorage.getItem('F44sGAGh2xwkpUL') != null &&
              sessionStorage.getItem('F44sGAGh2xwkpUL') != ""
            ) {
              let date = new Date();
              rid = date.getFullYear().toString() + date.getMonth().toString() + date.getDate().toString() + date.getHours().toString() + date.getMinutes().toString() + date.getSeconds().toString() + date.getMilliseconds().toString() + this.EncrdecrService.getDecr(sessionStorage.getItem("F44sGAGh2xwkpUL"));
            }
    
        let jid = "";
        let userType = 0;
        let initiatedBy = "";
    
        if (sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX') != undefined &&
            sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX') != null &&
            sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX') != "") {
              jid = this.EncrdecrService.setEncr(sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX'));
            }
    
            if (sessionStorage.getItem('L2D3506kIHSk3E0') != undefined &&
            sessionStorage.getItem('L2D3506kIHSk3E0') != null &&
            sessionStorage.getItem('L2D3506kIHSk3E0') != "") {
              userType = +this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'))
            }
    
            if (sessionStorage.getItem("F44sGAGh2xwkpUL") != undefined &&
            sessionStorage.getItem("F44sGAGh2xwkpUL") != null &&
            sessionStorage.getItem("F44sGAGh2xwkpUL") != "") {
              initiatedBy = this.EncrdecrService.getDecr(sessionStorage.getItem("F44sGAGh2xwkpUL"))
            }
    

    const body = 
    { data: this.EncrdecrService.setEncr(req_str) ,
      rid: rid,
      jid: jid,
      userType: userType,
      initiatedBy: initiatedBy 
    };
    return this.http.post<any>(url, body, tokenOption).pipe();
    // return this.http.post<any>(url, body, this.GetToken());
  }

  GetPortfolioComprehensiveReport(data): Observable<any> {
    let url = `${this.ServerUrl}/api/PortfolioComprehensive/Comprehensive`;
    const tokenOption = this.GetToken();
    let req_str = JSON.stringify(data);

    let rid = "";
    if (rid == "" && 
              sessionStorage.getItem('F44sGAGh2xwkpUL') != undefined &&
              sessionStorage.getItem('F44sGAGh2xwkpUL') != null &&
              sessionStorage.getItem('F44sGAGh2xwkpUL') != ""
            ) {
              let date = new Date();
              rid = date.getFullYear().toString() + date.getMonth().toString() + date.getDate().toString() + date.getHours().toString() + date.getMinutes().toString() + date.getSeconds().toString() + date.getMilliseconds().toString() + this.EncrdecrService.getDecr(sessionStorage.getItem("F44sGAGh2xwkpUL"));
            }
    
        let jid = "";
        let userType = 0;
        let initiatedBy = "";
    
        if (sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX') != undefined &&
            sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX') != null &&
            sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX') != "") {
              jid = this.EncrdecrService.setEncr(sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX'));
            }
    
            if (sessionStorage.getItem('L2D3506kIHSk3E0') != undefined &&
            sessionStorage.getItem('L2D3506kIHSk3E0') != null &&
            sessionStorage.getItem('L2D3506kIHSk3E0') != "") {
              userType = +this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'))
            }
    
            if (sessionStorage.getItem("F44sGAGh2xwkpUL") != undefined &&
            sessionStorage.getItem("F44sGAGh2xwkpUL") != null &&
            sessionStorage.getItem("F44sGAGh2xwkpUL") != "") {
              initiatedBy = this.EncrdecrService.getDecr(sessionStorage.getItem("F44sGAGh2xwkpUL"))
            }

    const body = { data: this.EncrdecrService.setEncr(req_str),
      rid: rid,
      jid: jid,
      userType: userType,
      initiatedBy: initiatedBy  };
    return this.http.post<any>(url, body, tokenOption).pipe();

    // return this.http.post<any>(url, body, this.GetToken());
  }


  PortfolioComprehensive(clientId, Employee, subBrokerId, LoginInUserId, Schemecode, AMCCode, AssetType, AsOnDate, FolioNo): Observable<any> {
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(sessionStorage.getItem('m5JkoXISmYRAIuY'));
    let User_Type = this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'));
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    console.log("tken " + token + "@" + UserId + "|" + User_Type + "|" + IpAddress)
    const TOKEN = btoa(token + "@" + UserId + "|" + User_Type + "|" + IpAddress);
    const tokenOption = {
      headers:
        new HttpHeaders(
          {
            'Content-Type': 'application/json',
            'Authorization': `Basic ${TOKEN}`,
          })
    }
    Employee = 0;
    //let FolioNo = "0";
    let url = `${this.ServerUrl}/api/PortfolioBreakdown/PortfolioComprehensive`;
    const QueryString = `CON_STR=MF&TRANS_TYPE=Client&ClientBasicInfoId=${clientId}&EMPLOYEE_CODE=${Employee}&SUB_BROKER_CODE=${subBrokerId}&LogInUserID_Code=${LoginInUserId}&SchemeCode=${Schemecode}&AMCCode=${AMCCode}&FolioNumber=${FolioNo}&AssetType=${AssetType}&FromDate=01-01-1901&EndDate=${AsOnDate}`;
    const body = this.ConvertToJSON.QueryStringToJSON(QueryString);
    console.log('Return Summary : ' + url);
    console.log('Return Summary body : ' + JSON.stringify(body));
    return this.http.post<any>(url, body, tokenOption);
  }

  GetHoldingSummaryAMCList() {
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(sessionStorage.getItem('m5JkoXISmYRAIuY'));
    let User_Type = this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'));
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(token + "@" + UserId + "|" + User_Type + "|" + IpAddress);
    // const tokenOption = {
    //   headers:
    //     new HttpHeaders(
    //       {
    //         'Content-Type': 'application/json',
    //         'Authorization': `Basic ${TOKEN}`,
    //       })
    // }
    let url = `${this.ServerUrl}/api/DropDown/ReportDetails?TRANS_TYPE=amc_list&REFF_ID=&CON_STR=MF&REFF_ID2=&REFF_ID3=`;
    //console.log(url)
    console.log("AMC List " + url);
    // let body = this.ConvertToJSON.QueryStringToJSON(url.split('?')[1]);

    const tokenOption = this.GetToken();
    const QueryString = url.split('?')[1];
    const body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(QueryString);
    return this.http.post<any>(url, body, tokenOption).pipe();
    // return this.http.post<any>(url.split('?')[0], body, tokenOption);
  }
  //#endregion
  GetReturnDetailReport(UserType, clientId, Employee, subBrokerId, LoginInUserId, AsOnDate, ReportType): Observable<any> {
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(sessionStorage.getItem('m5JkoXISmYRAIuY'));
    let User_Type = this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'));
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(token + "@" + UserId + "|" + User_Type + "|" + IpAddress);
    const tokenOption = {
      headers:
        new HttpHeaders(
          {
            'Content-Type': 'application/json',
            'Authorization': `Basic ${TOKEN}`,
          })
    }
    // Employee = 0;
    let url = `${this.ServerUrl}/api/HoldingDetailRepor`;

    let rid = "";
    if (rid == "" && 
              sessionStorage.getItem('F44sGAGh2xwkpUL') != undefined &&
              sessionStorage.getItem('F44sGAGh2xwkpUL') != null &&
              sessionStorage.getItem('F44sGAGh2xwkpUL') != ""
            ) {
              let date = new Date();
              rid = date.getFullYear().toString() + date.getMonth().toString() + date.getDate().toString() + date.getHours().toString() + date.getMinutes().toString() + date.getSeconds().toString() + date.getMilliseconds().toString() + this.EncrdecrService.getDecr(sessionStorage.getItem("F44sGAGh2xwkpUL"));
            }
    
        let jid = "";
        let initiatedBy = "";
    
        if (sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX') != undefined &&
            sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX') != null &&
            sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX') != "") {
              jid = this.EncrdecrService.setEncr(sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX'));
            }
    
            if (sessionStorage.getItem("F44sGAGh2xwkpUL") != undefined &&
            sessionStorage.getItem("F44sGAGh2xwkpUL") != null &&
            sessionStorage.getItem("F44sGAGh2xwkpUL") != "") {
              initiatedBy = this.EncrdecrService.getDecr(sessionStorage.getItem("F44sGAGh2xwkpUL"))
            }

    const QueryString = `ClientBasicInfoId=${clientId}&EMPLOYEE_CODE=${Employee}&SUB_BROKER_CODE=${subBrokerId}&LogInUserID_Code=${LoginInUserId}&FromDate=01-01-1901&EndDate=${AsOnDate}&REFF_ID=0&REFF_ID=${ReportType}&UserType=${UserType}&rid=${rid}&jid=${jid}&initiatedBy=${initiatedBy}`;
    const body = this.ConvertToJSON.QueryStringToJSON(QueryString);
    console.log('Detailed Holding Request ');
    console.log(JSON.stringify(body));
    return this.http.post<any>(url, body, tokenOption);
  }
  //#region Capital Gain Report
  GET_CapitalGainReport(USER_TYPE, ClientBasicInfoIdList, FromDate, EndDate, GrandFather, FinancialYear, LoginInUserId, Employee, subBrokerId, Role_ID): Observable<any> {
    //debugger
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(sessionStorage.getItem('m5JkoXISmYRAIuY'));
    let User_Type = this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'));
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(token + "@" + UserId + "|" + User_Type + "|" + IpAddress);
    // const tokenOption = {
    //   headers:
    //     new HttpHeaders(
    //       {
    //         'Content-Type': 'application/json',
    //         'Authorization': `Basic ${TOKEN}`,
    //       })
    // }
    Employee = 0;
    if (USER_TYPE == 3) { subBrokerId = "0" }
    let url = `${this.ServerUrl}/api/CapitalGainWithAndWithoutIndexsation/Details`;
    const QueryString = `TRANS_TYPE=CLIENT_ID&Employee=${Employee}&SubBroker=${subBrokerId}&USER_TYPE=${USER_TYPE}&LogInUserID_Code=${LoginInUserId}&ClientBasicInfoIdList=${ClientBasicInfoIdList}&FromDate=${FromDate}&EndDate=${EndDate}&GrandFather=${GrandFather}&FinancialYear=${FinancialYear}&select_type=true&Role_ID=${Role_ID}`;
    // const body = this.ConvertToJSON.QueryStringToJSON(QueryString);
    //console.log('WI='+url)
    console.log("Capital Gain Report With Indexion")
    console.log(url)
    console.log(token + "@" + UserId + "|" + User_Type + "|" + IpAddress)
    // url = url + '?' + QueryString
    const tokenOption = this.GetToken();
    const body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(QueryString);
    console.log(JSON.stringify(body))
    return this.http.post<any>(url, body, tokenOption).pipe();
    // return this.http.post<any>(url, body, tokenOption);
  }

  GET_CapitalGainWithoutIndexation(USER_TYPE, ClientBasicInfoIdList, FromDate, EndDate, GrandFather, FinancialYear, LoginInUserId, Employee, subBrokerId, Role_ID): Observable<any> {
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(sessionStorage.getItem('m5JkoXISmYRAIuY'));
    let User_Type = this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'));
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(token + "@" + UserId + "|" + User_Type + "|" + IpAddress);
    // const tokenOption = {
    //   headers:
    //     new HttpHeaders(
    //       {
    //         'Content-Type': 'application/json',
    //         'Authorization': `Basic ${TOKEN}`,
    //       })
    // }
    Employee = 0;
    if (USER_TYPE == 3) { subBrokerId = "0" }
    let url = `${this.ServerUrl}/api/CapitalGainWithAndWithoutIndexsation/Details`;
    const QueryString = `TRANS_TYPE=CLIENT_ID&Employee=${Employee}&SubBroker=${subBrokerId}&USER_TYPE=${USER_TYPE}&LogInUserID_Code=${LoginInUserId}&ClientBasicInfoIdList=${ClientBasicInfoIdList}&FromDate=${FromDate}&EndDate=${EndDate}&GrandFather=${GrandFather}&FinancialYear=${FinancialYear}&select_type=false`;
    // const body = this.ConvertToJSON.QueryStringToJSON(QueryString);

    //console.log('WOI='+url)
    console.log("Capital Gain Report Without Indexion")
    console.log(url)
    console.log(token + "@" + UserId + "|" + User_Type + "|" + IpAddress)
    const tokenOption = this.GetToken();
    const body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(QueryString);
    console.log(JSON.stringify(body))
    return this.http.post<any>(url, body, tokenOption).pipe();

    // return this.http.post<any>(url, body, tokenOption);
  }

  Get_FinancialYear() {
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(sessionStorage.getItem('m5JkoXISmYRAIuY'));
    let User_Type = this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'));
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(token + "@" + UserId + "|" + User_Type + "|" + IpAddress);
    // const tokenOption = {
    //   headers:
    //     new HttpHeaders(
    //       {
    //         'Content-Type': 'application/json',
    //         'Authorization': `Basic ${TOKEN}`,
    //       })
    // }
    const url = `${this.ServerUrl}/api/DropDown/ReportDetails?TRANS_TYPE=FinancialYears`;
    // let body = this.ConvertToJSON.QueryStringToJSON(url.split('?')[1]);
    const tokenOption = this.GetToken();
    const QueryString = url.split('?')[1];
    const body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(QueryString);
    return this.http.post<any>(url, body, tokenOption).pipe();
    // return this.http.post<any>(url.split('?')[0], body, tokenOption);
  }
  //#endregion

  Get_DividendDetails(FromDate, EndDate, UserType, ClientId) {
    let url = `${this.ServerUrl}/api/DividendDetails/Details`;
    const QueryString = `TRANS_TYPE=CLIENT_ID&Flag=CLIENT_ID&FromDate=${FromDate}&EndDate=${EndDate}&UserType=${UserType}&ClientBasicInfoId=${ClientId}&ClientBasicInfoIdList=${ClientId}`;
    const body = this.ConvertToJSON.QueryStringToJSON(QueryString);
    //console.log(url)
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(sessionStorage.getItem('m5JkoXISmYRAIuY'));
    let User_Type = this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'));
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(token + "@" + UserId + "|" + User_Type + "|" + IpAddress);
    const tokenOption = {
      headers:
        new HttpHeaders(
          {
            'Content-Type': 'application/json',
            'Authorization': `Basic ${TOKEN}`,
          })
    }
    // return this.http.post<any>(url, formData, tokenOption)
    console.log("Dividend Report Data")
    console.log(url);
    console.log(JSON.stringify(body));
    console.log(token + "@" + UserId + "|" + User_Type + "|" + IpAddress);
    return this.http.post<any>(url, body, tokenOption)
  }

  //#region Transaction Report
  GetTransactionReport(formData): Observable<any> {
    // FromDate, EndDate, AMCCode, SchemeCode, TransactionType, TransactionSubType
    // , NATURE, SubNature, USER_TYPE, LogInUserID_Code, Role_ID,

    let url = `${this.ServerUrl}/api/ViewTransaction/Details`;

    // ?TRANS_TYPE=CLIENT_ID&FromDate=${FromDate}&EndDate=${EndDate}&AMCCode=${AMCCode}&SchemeCode=${SchemeCode}&TransactionType=${TransactionType}&TransactionSubType=${TransactionSubType}&NATURE=${NATURE}&SubNature=${SubNature}&USER_TYPE=${USER_TYPE}&LogInUserID_Code=${LogInUserID_Code}&Role_ID=${Role_ID}&PageIndex=1&Flag=Page&PageSize=100`
    const tokenOption = this.GetToken();
    // const url = DataUrl.split('?')[0];
    // const QueryString = DataUrl.split('?')[1];
    // const body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(QueryString);
    // let req_str = JSON.stringify(formData);
    const body = { data: this.EncrdecrService.setEncr(formData) };
    // return this.http.post<any>(url, formData, this.GetToken());
    return this.http.post<any>(url, body, tokenOption).pipe();

  }

  GetTransactionRTAWiseReport(formData): Observable<any> {
    // FromDate, EndDate, AMCCode, SchemeCode, TransactionType, TransactionSubType
    // , NATURE, SubNature, USER_TYPE, LogInUserID_Code, Role_ID,

    let url = `${this.ServerUrl}/api/ViewTransaction/TransactionRTAWiseDetails`;

    // ?TRANS_TYPE=CLIENT_ID&FromDate=${FromDate}&EndDate=${EndDate}&AMCCode=${AMCCode}&SchemeCode=${SchemeCode}&TransactionType=${TransactionType}&TransactionSubType=${TransactionSubType}&NATURE=${NATURE}&SubNature=${SubNature}&USER_TYPE=${USER_TYPE}&LogInUserID_Code=${LogInUserID_Code}&Role_ID=${Role_ID}&PageIndex=1&Flag=Page&PageSize=100`
    const tokenOption = this.GetToken();
    // const url = DataUrl.split('?')[0];
    // const QueryString = DataUrl.split('?')[1];
    // const body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(QueryString);
    // let req_str = JSON.stringify(formData);
    const body = { data: this.EncrdecrService.setEncr(formData) };
    // return this.http.post<any>(url, formData, this.GetToken());
    return this.http.post<any>(url, body, tokenOption).pipe();
  }

  GetTransactionReport_COB(formData): Observable<any> {
    // FromDate, EndDate, AMCCode, SchemeCode, TransactionType, TransactionSubType
    // , NATURE, SubNature, USER_TYPE, LogInUserID_Code, Role_ID,

    let url = `${this.ServerUrl}/api/ViewTransaction_COB/Details`;

    // ?TRANS_TYPE=CLIENT_ID&FromDate=${FromDate}&EndDate=${EndDate}&AMCCode=${AMCCode}&SchemeCode=${SchemeCode}&TransactionType=${TransactionType}&TransactionSubType=${TransactionSubType}&NATURE=${NATURE}&SubNature=${SubNature}&USER_TYPE=${USER_TYPE}&LogInUserID_Code=${LogInUserID_Code}&Role_ID=${Role_ID}&PageIndex=1&Flag=Page&PageSize=100`
    const tokenOption = this.GetToken();
    // const url = DataUrl.split('?')[0];
    // const QueryString = DataUrl.split('?')[1];
    // const body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(QueryString);
    // let req_str = JSON.stringify(formData);
    const body = { data: this.EncrdecrService.setEncr(formData) };
    // return this.http.post<any>(url, formData, this.GetToken());
    return this.http.post<any>(url, body, tokenOption).pipe();
  }

  GetNature() {
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(sessionStorage.getItem('m5JkoXISmYRAIuY'));
    let User_Type = this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'));
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(token + "@" + UserId + "|" + User_Type + "|" + IpAddress);
    const tokenOption = {
      headers:
        new HttpHeaders(
          {
            'Content-Type': 'application/json',
            'Authorization': `Basic ${TOKEN}`,
          })
    }
    let url = `${this.ServerUrl}/api/DropDown/GetDetails?TRANS_TYPE=Nature&REFF_ID=&REFF_ID2=&REFF_ID3=&CON_STR=MF`;
    console.log("Asset Type API")
    console.log(url)
    let body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(url.split('?')[1]);
    return this.http.post<any>(url.split('?')[0], body, tokenOption);
  }
  GetSubNature(nature) {
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(sessionStorage.getItem('m5JkoXISmYRAIuY'));
    let User_Type = this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'));
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(token + "@" + UserId + "|" + User_Type + "|" + IpAddress);
    const tokenOption = {
      headers:
        new HttpHeaders(
          {
            'Content-Type': 'application/json',
            'Authorization': `Basic ${TOKEN}`,
          })
    }
    let url = `${this.ServerUrl}/api/DropDown/GetDetails?TRANS_TYPE=TransSubNature&REFF_ID=${nature}&REFF_ID2=&REFF_ID3=&CON_STR=MF`;
    console.log("Transaction Report Sub Nature")
    console.log(url)
    console.log(token + "@" + UserId + "|" + User_Type + "|" + IpAddress)
    let body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(url.split('?')[1]);
    return this.http.post<any>(url.split('?')[0], body, tokenOption);
  }
  GetSubTransactionType(TransactionType) {
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(sessionStorage.getItem('m5JkoXISmYRAIuY'));
    let User_Type = this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'));
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(token + "@" + UserId + "|" + User_Type + "|" + IpAddress);
    const tokenOption = {
      headers:
        new HttpHeaders(
          {
            'Content-Type': 'application/json',
            'Authorization': `Basic ${TOKEN}`,
          })
    }
    let url = `${this.ServerUrl}/api/DropDown/GetDetails?TRANS_TYPE=TransactionTypeALL&REFF_ID=${TransactionType}&REFF_ID2=&REFF_ID3=&CON_STR=MF`;
    console.log("Transaction Report Sub Transaction Type")
    console.log(url)
    console.log(token + "@" + UserId + "|" + User_Type + "|" + IpAddress)
    let body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(url.split('?')[1]);
    return this.http.post<any>(url.split('?')[0], body, tokenOption);

  }
  GetTransactionAMCList() {
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(sessionStorage.getItem('m5JkoXISmYRAIuY'));
    let User_Type = this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'));
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(token + "@" + UserId + "|" + User_Type + "|" + IpAddress);
    const tokenOption = {
      headers:
        new HttpHeaders(
          {
            'Content-Type': 'application/json',
            'Authorization': `Basic ${TOKEN}`,
          })
    }
    let url = `${this.ServerUrl}/api/DropDown/GetDetails?TRANS_TYPE=FundHouse_list&REFF_ID=&REFF_ID2=&REFF_ID3=&CON_STR=MF`;
    //console.log(url)
    console.log("Transaction Report AMC List");
    console.log(url)
    console.log(token + "@" + UserId + "|" + User_Type + "|" + IpAddress)
    let body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(url.split('?')[1]);
    return this.http.post<any>(url.split('?')[0], body, tokenOption);
  }
  //#endregion

  //used in Transaction Report and Return Summary
  GetTransactionSchemeList(AMCCode, ClientId) {
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(sessionStorage.getItem('m5JkoXISmYRAIuY'));
    let User_Type = this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'));
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(token + "@" + UserId + "|" + User_Type + "|" + IpAddress);
    // const tokenOption = {
    //   headers:
    //     new HttpHeaders(
    //       {
    //         'Content-Type': 'application/json',
    //         'Authorization': `Basic ${TOKEN}`,
    //       })
    // }
    let DataUrl = `${this.ServerUrl}/api/DropDown/ReportDetails?TRANS_TYPE=ClientWiseSchemeCode&REFF_ID=${ClientId}&REFF_ID2=${AMCCode}&REFF_ID3=&CON_STR=MF`;
    // let body = this.ConvertToJSON.QueryStringToJSON(url.split('?')[1]);
    const tokenOption = this.GetToken();
    const url = DataUrl.split('?')[0];
    console.log("Transaction API Scheme API " + url);
    const QueryString = DataUrl.split('?')[1];
    const body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(QueryString);
    return this.http.post<any>(url, body, tokenOption).pipe();
    // return this.http.post<any>(url.split('?')[0], body, tokenOption);
  }
  //not used
  GetTransactionSubType() {
    let url = `${this.ServerUrl}/api/DropDown/GetDetails?TRANS_TYPE=TransactionType&REFF_ID=&REFF_ID2=&REFF_ID3=&CON_STR=MF`;
    let body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(url.split('?')[1]);
    let tokenOption = this.GetToken();
    return this.http.post<any>(url.split('?')[0], body, tokenOption);

  }


  //#region explore Funds Services
  GetExploreFundsData(typeoption) {

    let url = `${this.ServerUrl}/api/BSESchemeList/SchemeList?SchemePlan=${typeoption}`;
    // let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    // let UserId = this.EncrdecrService.getDecr(sessionStorage.getItem('m5JkoXISmYRAIuY'));
    // let User_Type = this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'));
    // let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    // const TOKEN = btoa(token + "@" + UserId + "|" + User_Type + "|" + IpAddress);
    const tokenOption = {
      headers:
        new HttpHeaders(
          {
            'Content-Type': 'application/json',
            //'Authorization': `Basic ${TOKEN}`,
          })
    }
    console.log(url)
    const body = url.split('?')[1];
    let request = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(body);
    return this.http.post<any[]>(url.split('?')[0], request, tokenOption).pipe();
  }

  //Added By Devang Mehta On 24/12/2024
  GetExploreFundsDataNew(typeoption, PurchaseTransactionMode) {

    let url = `${this.ServerUrl}/api/BSESchemeList/SchemeList?SchemePlan=${typeoption}&PurchaseTransactionMode=${PurchaseTransactionMode}`;
    // let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    // let UserId = this.EncrdecrService.getDecr(sessionStorage.getItem('m5JkoXISmYRAIuY'));
    // let User_Type = this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'));
    // let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    // const TOKEN = btoa(token + "@" + UserId + "|" + User_Type + "|" + IpAddress);
    const tokenOption = {
      headers:
        new HttpHeaders(
          {
            'Content-Type': 'application/json',
            //'Authorization': `Basic ${TOKEN}`,
          })
    }
    console.log(url)
    const body = url.split('?')[1];
    let request = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(body);
    return this.http.post<any[]>(url.split('?')[0], request, tokenOption).pipe();
  }
  //End By Devang Mehta
  //#endregion
  GetExploreFundsData_NSE() {
    let url = `${this.ServerUrl}/api/NSESchemeList/SchemeList`;
    const header = this.GetToken();
    return this.http.post<any[]>(url, '', header).pipe();
  }
  // Get IIN Report Data
  getIINReportData(ClientBasicInfoId, UserType, SelectType, UserId, Role_ID) {
    // tslint:disable-next-line: max-line-length
    const DataUrl = `${this.ServerUrl}/api/ClientACHMandate/IINDetailsList?REFF_ID=${ClientBasicInfoId}&UserType=${UserType}&select_type=${SelectType}&USER_ID=${UserId}&Role_ID=${Role_ID}`;
    console.log('IIN Report URL ' + DataUrl);
    const tokenOption = this.GetToken();
    const url = DataUrl.split('?')[0];
    const QueryString = DataUrl.split('?')[1];
    const body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(QueryString);
    return this.http.post<any>(url, body, tokenOption).pipe();

    // return this.http.get<any>(url);
  }
  // End of IIN Report Data

  // getting NSE Family List
  getNSEFamilyDetails(REFF_ID) {
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(sessionStorage.getItem('m5JkoXISmYRAIuY'));
    let User_Type = this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'));
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(token + "@" + UserId + "|" + User_Type + "|" + IpAddress);
    const tokenOption = {
      headers:
        new HttpHeaders(
          {
            'Content-Type': 'application/json',
            'Authorization': `Basic ${TOKEN}`,
          })
    }
    return this.http.get<any>(`${this.ServerUrl}/api/ClientFamilyGroup/Details?TRANS_TYPE=&REFF_ID=${REFF_ID}`, tokenOption);
  }
  // end

  // Getting NSE Family Members
  Get_NSEFamilyDetail(UserType, LoginUserId) {
    // //////
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(sessionStorage.getItem('m5JkoXISmYRAIuY'));
    let User_Type = this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'));
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(token + "@" + UserId + "|" + User_Type + "|" + IpAddress);
    const tokenOption = {
      headers:
        new HttpHeaders(
          {
            'Content-Type': 'application/json',
            'Authorization': `Basic ${TOKEN}`,
          })
    }
    let DataUrl: string;
    if (UserType === '3') {
      DataUrl = `${this.ServerUrl}/api/ClientFamilyGroup/GetFamilyList?PrefixText=&LoginUserId=${this.EncrdecrService.setEncr(LoginUserId)}&TRANS_TYPE=EMPLOYEE`;
    } else {
      DataUrl = `${this.ServerUrl}/api/ClientFamilyGroup/GetFamilyList?PrefixText=&LoginUserId=${this.EncrdecrService.setEncr(LoginUserId)}&TRANS_TYPE=SUBBROKER`;
    }
    // console.log(url)

    const url = DataUrl.split('?')[0];
    const QueryString = DataUrl.split('?')[1];
    const body = this.ConvertToJSON.QueryStringToJSON(QueryString);
    return this.http.post<any>(url, body, tokenOption);
  }
  // end

  // Get NSE Orderbook Report Data
  getNSEOrderBook(FromDate, EndDate, ClientBasicInfoId, ApplicationId, PWD, Broker_code, UniqueNo, Role_ID, ClientID) {

    // tslint:disable-next-line: max-line-length
    const DataUrl = `${this.ServerUrl}/api/NSEReport/GetOrderDetails?FromDate=${FromDate}&EndDate=${EndDate}&CUSTOMER_ID=${ClientBasicInfoId}&APPLN_ID=${ApplicationId}&PWD=${PWD}&BROKER_CODE=${Broker_code}&unique_no=${UniqueNo}&Role_ID=${Role_ID}&ClientBasicInfoIdList=${ClientID}`;
    console.log('nse order book data' + DataUrl)
    const tokenOption = this.GetToken();
    const url = DataUrl.split('?')[0];
    const QueryString = DataUrl.split('?')[1];
    const body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(QueryString);
    return this.http.post<any>(url, body, tokenOption).pipe();
    // return this.http.get<any>(url);
  }
  // End of IIN Report Data

  // Get NSE Orderbook Report Data
  getNSECredential() {
    // tslint:disable-next-line: max-line-length
    const header = this.GetToken();
    const url = `${this.ServerUrl}/api/NSETransactionCommon/GetNSECredentialSetting`;
    return this.http.get<any>(url, header);
  }
  // End of IIN Report Data

  // Get NSE Orderbook Report Data
  getClientsIIN(ClientBasicInfoId) {
    // tslint:disable-next-line: max-line-length
    const DataUrl = `${this.ServerUrl}/api/NSEReport/GetClientUCCDetails?ClientBasicInfoId=${ClientBasicInfoId}&Flag=Comma`;
    const tokenOption = this.GetToken();
    const url = DataUrl.split('?')[0];
    const QueryString = DataUrl.split('?')[1];
    const body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(QueryString);
    return this.http.post<any>(url, body, tokenOption).pipe();
    // return this.http.get<any>(url);
  }
  // End of IIN Report Data
  // Get NSE Orderbook Report Data
  getACHMandateData(ClientBasicInfoId, UserType, Role_ID) {
    // tslint:disable-next-line: max-line-length
    const DataUrl = `${this.ServerUrl}/api/ClientACHMandate/ACHMandateList?REFF_ID=${ClientBasicInfoId}&UserType=${UserType}&Role_ID=${Role_ID}`;
    const tokenOption = this.GetToken();
    const url = DataUrl.split('?')[0];
    const QueryString = DataUrl.split('?')[1];
    const body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(QueryString);
    return this.http.post<any>(url, body, tokenOption).pipe();
    // return this.http.get<any>(url);
  }
  // End of IIN Report Data

  // Get PMS Transaction Data
  // getPMSTransaction(TRANS_TYPE, UserType, LogInUserID_Code, FromDate, EndDate, ClientBasicInfoId) {
  //   // tslint:disable-next-line: max-line-length
  //   const url = `${this.ServerUrl}/api/ViewTransactionPMS?TRANS_TYPE=${TRANS_TYPE}&USER_TYPE=${UserType}&LogInUserID_Code=${LogInUserID_Code}&PageIndex=1&Flag=Page&FromDate=${FromDate}&EndDate=${EndDate}&PageSize=999999&ClientBasicInfoIdList=${ClientBasicInfoId}`;
  //   return this.http.get<any>(url);
  // }
  getPMSTransaction(TRANS_TYPE, UserType, LogInUserID_Code, FromDate, EndDate, ClientBasicInfoId, Role_ID) {
    debugger
    // tslint:disable-next-line: max-line-length
    let DataUrl = `${this.ServerUrl}/api/ViewTransactionPMS`;
    const QueryString = `TRANS_TYPE=${TRANS_TYPE}&USER_TYPE=${UserType}&LogInUserID_Code=${LogInUserID_Code}&PageIndex=1&Flag=Page&FromDate=${FromDate}&EndDate=${EndDate}&PageSize=999999&ClientBasicInfoIdList=${ClientBasicInfoId}&Role_ID=${Role_ID}`;
    // const body = this.ConvertToJSON.QueryStringToJSON(QueryString);
    // url = url + '?' + QueryString;
    // return this.http.post<any>(url, body, this.GetToken());
    const tokenOption = this.GetToken();
    const url = DataUrl.split('?')[0];
    const body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(QueryString);
    return this.http.post<any>(url, body, tokenOption).pipe();
  }
  // End PMS Transaction Data

  // Get DE Transaction Data
  getDETransaction(TRANS_TYPE, UserType, LogInUserID_Code, FromDate, EndDate, ClientBasicInfoId) {
    // tslint:disable-next-line: no-shadowed-variable
    const headers = { 'content-type': 'application/json' };
    const data = { ClientBasicInfoIdList: ClientBasicInfoId };
    const body = JSON.stringify(data);
    // tslint:disable-next-line: max-line-length
    const url = `${this.ServerUrl}/api/ViewTransactionDE?TRANS_TYPE=${TRANS_TYPE}&USER_TYPE=${UserType}&LogInUserID_Code=${LogInUserID_Code}&PageIndex=1&Flag=Page&FromDate=${FromDate}&EndDate=${EndDate}&PageSize=999999`;
    return this.http.post<any>(url, body, { headers });
  }
  // End Get DE Transaction Data

  // Get AIF Transaction Data
  getAIFTransaction(TRANS_TYPE, UserType, LogInUserID_Code, ClientBasicInfoId, Role_ID) {
    // tslint:disable-next-line: no-shadowed-variable
    // const headers = { 'content-type': 'application/json' };
    // const data = { ClientBasicInfoIdList: ClientBasicInfoId };
    // const body = JSON.stringify(data);
    // tslint:disable-next-line: max-line-length
    const tokenOption = this.GetToken();
    const DataUrl = `${this.ServerUrl}/api/AIFLedgerRepor?TRANS_TYPE=CLIENT_ID&USER_TYPE=${UserType}&LogInUserID_Code=${LogInUserID_Code}&Role_ID=${Role_ID}&ClientBasicInfoIdList=${ClientBasicInfoId}`;
    const url = DataUrl.split('?')[0];
    const QueryString = DataUrl.split('?')[1];
    const body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(QueryString);
    return this.http.post<any>(url, body, tokenOption).pipe();
    // return this.http.post<any>(url, body, { headers });
  }
  // End Get AIF Transaction Data

  // Get PMS Holding Data
  getPMSHoldings(TRANS_TYPE, UserType, LogInUserID_Code, ClientBasicInfoId, Role_ID) {
    // tslint:disable-next-line: max-line-length
    // const headers = { 'content-type': 'application/json' };
    // const data = { ClientBasicInfoIdList: ClientBasicInfoId };
    // const body = JSON.stringify(data);
    // tslint:disable-next-line: max-line-length
    const tokenOption = this.GetToken();
    const DataUrl = `${this.ServerUrl}/api/HoldingReportPMS?TRANS_TYPE=${TRANS_TYPE}&USER_TYPE=${UserType}&LogInUserID_Code=${LogInUserID_Code}&PageIndex=1&Flag=Page&PageSize=999999&ClientBasicInfoIdList=${ClientBasicInfoId}&Role_ID=${Role_ID}`;
    const url = DataUrl.split('?')[0];
    const QueryString = DataUrl.split('?')[1];
    const body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(QueryString);
    return this.http.post<any>(url, body, tokenOption).pipe();
    // return this.http.post<any>(url, body, { headers });
  }
  // End PMS Transaction Data

  // Get PMS Transaction Data
  getPMSSales(TRANS_TYPE, UserType, LogInUserID_Code, FromDate, EndDate, ClientBasicInfoId, Role_ID) {
    // tslint:disable-next-line: max-line-length
    const DataUrl = `${this.ServerUrl}/api/NetSaleReportPMS?ClientBasicInfoIdList=${ClientBasicInfoId}&TRANS_TYPE=${TRANS_TYPE}&Employee=0&SubBroker=0&USER_TYPE=${UserType}&LogInUserID_Code=${LogInUserID_Code}&Role_ID=${Role_ID}&FromDate=${FromDate}&EndDate=${EndDate}`;
    const tokenOption = this.GetToken();
    const url = DataUrl.split('?')[0];
    const QueryString = DataUrl.split('?')[1];
    const body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(QueryString);
    return this.http.post<any>(url, body, tokenOption).pipe();
    // return this.http.get<any>(url);
  }
  // End PMS Transaction Data

  // Get DE Holding Data
  getDEHoldings(TRANS_TYPE, UserType, LogInUserID_Code, ClientBasicInfoId, EmpId, SBId, Role_ID) {
    // tslint:disable-next-line: max-line-length
    // const headers = { 'content-type': 'application/json' };
    const tokenOption = this.GetToken();
    const data = {
      ClientBasicInfoIdList: ClientBasicInfoId, EMPID: EmpId, SBID: SBId, 'QueryStringData': [
        {
          'TRANS_TYPE': TRANS_TYPE, 'UserType': UserType, 'LoginId': LogInUserID_Code, 'RoleId': Role_ID
        }
      ]
    };
    const body = { data: this.EncrdecrService.setEncr(JSON.stringify(data)) };
    // tslint:disable-next-line: max-line-length
    // ?TRANS_TYPE=${TRANS_TYPE}&USER_TYPE=${UserType}&LogInUserID_Code=${LogInUserID_Code}&Role_ID=0
    const url = `${this.ServerUrl}/api/HoldingReportDE`;
    return this.http.post<any>(url, body, tokenOption);
  }
  // End De Holding Data

  // Get Calculated XIRRR by ClientBasicInfo Id
  getCalculatedXIRR(ClientBasicInfoId) {
    let DataUrl = `${this.ServerUrl}/api/Reports_All_IN_OneView/GetClientHoldingTransction?CLIENT_ID=${ClientBasicInfoId}`;
    const tokenOption = this.GetToken();
    const url = DataUrl.split('?')[0];
    const QueryString = DataUrl.split('?')[1];
    const body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(QueryString);
    return this.http.post<any>(url, body, tokenOption).pipe();
    // return this.http.get<any>(``);
  }
  // end of getinig XIRRR

  // Get DE Capital Gain
  getDECapitalGain(TRANS_TYPE, UserType, LogInUserID_Code, ClientBasicInfoId, EmpId, SBId, FromDate, ToDate) {
    // tslint:disable-next-line: max-line-length
    const url = `${this.ServerUrl}/api/CapitalGainWithAndWithoutIndexsationDE?TRANS_TYPE=${TRANS_TYPE}&Employee=${EmpId}&SubBroker=${SBId}&USER_TYPE=${UserType}&LogInUserID_Code=${LogInUserID_Code}&Role_ID=0&TYPE=&ClientBasicInfoIdList=${ClientBasicInfoId}&FromDate=${FromDate}&EndDate=${ToDate}`;
    const body = this.ConvertToJSON.QueryStringToJSON(url.split('?')[1]);
    const header = this.GetToken();
    return this.http.post<any>(url.split('?')[0], body, header);
  }
  // end of getinig DE Capital Gain

  // OneView Report Data
  getOneViewReport(TRANS_TYPE, UserType, LogInUserID_Code, ClientBasicInfoId, EmpId, SBCode, FromDate, ToDate, Role_ID) {
    // tslint:disable-next-line: max-line-length
    const DataUrl = `${this.ServerUrl}/api/Reports_All_IN_OneView/Details?CLIENT_ID=${ClientBasicInfoId}&EMPLOYEE_CODE=0&SUBBROKER_CODE=${SBCode}&TRANS_TYPE=${TRANS_TYPE}&FromDate=${FromDate}&EndDate=${ToDate}&LogInUserID_Code=${LogInUserID_Code}&ModuleName=Page&Role_ID=${Role_ID}`;
    // const body = this.ConvertToJSON.QueryStringToJSON(url.split('?')[1]);
    const tokenOption = this.GetToken();
    // return this.http.post<any>(url.split('?')[0], body, header);
    const url = DataUrl.split('?')[0];
    const QueryString = DataUrl.split('?')[1];
    const body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(QueryString);
    return this.http.post<any>(url, body, tokenOption).pipe();

  }
  // end of OneView Report Data
  getMFOneViewXIRR(ClientId) {
    const url = `${this.ServerUrl}/api/Reports_All_IN_OneView/GetClientHoldingTransction?CLIENT_ID=${ClientId}&AssetType=`;
    const body = this.ConvertToJSON.QueryStringToJSON(url.split('?')[1]);
    const header = this.GetToken();
    return this.http.post<any>(url.split("?")[0], body, header);
  }
  getDEOneViewXIRR(ClientId) {

    const url = `${this.ServerUrl}/api/Reports_All_IN_OneView/GetClientHoldingTransctionWithFilterXIRRPMS?CLIENT_ID=${ClientId}&AssetType=&FolioNumber=&SchemeCode=&AMCCode=`;

    const header = this.GetToken();
    const body = this.ConvertToJSON.QueryStringToJSON(url.split('?')[1]);
    return this.http.post<any>(url.split("?")[0], body, header);
  }
  getPMSOneViewXIRR(ClientId) {
    return this.http.get<any>(`${this.ServerUrl}/api/Reports_All_IN_OneView/GetClientHoldingTransctionDetails?CLIENT_ID=${ClientId}&AssetType=`);
  }
  //////////////////////////EMPLOYEE////////////////////////////

  EmployeeDashboard(LOGIN_ID, USER_ID, USER_TYPE) {
    let Url = `${this.ServerUrl}/api/BirlaSubbrokerLandingDashBoard/Details?LOGIN_ID=${LOGIN_ID}&USER_ID=${USER_ID}&USER_TYPE=${USER_TYPE}`;
    const header = this.GetToken();
    const body = this.ConvertToJSON.QueryStringToJSON(Url.split('?')[1]);
    return this.http.post<any>(Url.split('?')[0], body, header);
  }
  MF_Dashboard(LOGIN_ID, Role_ID) {
    let Url = `${this.ServerUrl}/api/EmployeeDashboard/Details?LOGIN_ID=${LOGIN_ID}&Role_ID=${Role_ID}`;
    let json = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(Url.split('?')[1]);
    var header = this.GetToken();
    return this.http.post<any>(Url.split('?')[0], json, header);
  }
  Post_PortfolioAllocation(formData) {
    let Url = `${this.ServerUrl}/api/Portfolioallocationreport/Details`;
    return this.http.post<any>(Url, formData, headers);
  }

  //ClientBasicInfoId, FromDate, EndDate
  Post_FMP_Report(formData) {
    let Url = `${this.ServerUrl}/api/FMPReport/FMPReport`;
    //let Url=`${this.ServerUrl}/api/FMPReport/FMPReport?CON_STR=MF&TRANS_TYPE=Client&ClientBasicInfoId=8166&EMPLOYEE_CODE=0&SUB_BROKER_CODE=0&LogInUserID_Code=ADMIN&SchemeCode=0&AMCCode=0&FolioNumber=0&AssetType=0&FromDate=01-01-1900&EndDate=12-01-2021`;
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(sessionStorage.getItem('m5JkoXISmYRAIuY'));
    let User_Type = this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'));
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(token + "@" + UserId + "|" + User_Type + "|" + IpAddress);
    // const tokenOption = {
    //   headers:
    //     new HttpHeaders(
    //       {
    //         'Content-Type': 'application/json',
    //         'Authorization': `Basic ${TOKEN}`,
    //       })
    // }
    const tokenOption = this.GetToken();
    let req_str = JSON.stringify(formData);
    const body = { data: this.EncrdecrService.setEncr(req_str) };
    return this.http.post<any>(Url, body, tokenOption).pipe();
    // return this.http.post<any>(Url, formData, tokenOption);
  }

  DetailTransactionWithGainReport(FromDate, EndDate, ClientBasicInfoId) {
    let Url = `${this.ServerUrl}/api/DetailTransactionwithGainReport?TRANS_TYPE=CLIENT_ID&FromDate=${FromDate}&EndDate=${EndDate}&ClientBasicInfoId=${ClientBasicInfoId}&BRANCH_ID=0`;
    return this.http.get<any>(Url);
  }

  Get_NonSIP_Report(formData) {
    let Url = `${this.ServerUrl}/api/NonSIPReport/Details`;
    return this.http.post<any>(Url, formData, headers);
  }

  Post_TaxSaving_Report(formData) {
    let Url = `${this.ServerUrl}/api/TaxSavingReport/Details`;
    return this.http.post<any>(Url, formData, headers);
  }
  getCompanyDetails(CompanyId) {
    //let Url = `http://173.249.23.172:9013/api/CompanyDetails/Details`;
    let Url = `${this.ServerUrl}/api/CompanyDetails/Details`;
    const QueryString = `Flag=${this.EncrdecrService.setEncr('CompanyWise')}&CompanyId=${this.EncrdecrService.setEncr(CompanyId)}`;
    // const QueryString = `Flag=CompanyWise&CompanyId=${CompanyId}`;
    const body = this.ConvertToJSON.QueryStringToJSON(QueryString);
    return this.http.post<any>(Url, body, headers);
  }
  BindEmployeeFilters(LOGIN_ID, UserType, Trans_Type, request) {
    ////////
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(sessionStorage.getItem('m5JkoXISmYRAIuY'));
    let User_Type = this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'));
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(token + "@" + UserId + "|" + User_Type + "|" + IpAddress);
    const tokenOption = {
      headers:
        new HttpHeaders(
          {
            'Content-Type': 'application/json',
            'Authorization': `Basic ${TOKEN}`,
          })
    }
    const req = { "data": this.EncrdecrService.setEncr(request) }
    let url = `${this.ServerUrl}/api/ReportFilter/Details?TRANS_TYPE=${Trans_Type}&LOGIN_ID=${this.EncrdecrService.setEncr(LOGIN_ID)}&USER_TYPE=1`;
    console.log('BindEmployeeFilters url ' + url);
    console.log('BindEmployeeFilters token ' + token + "@" + UserId + "|" + User_Type + "|" + IpAddress);
    return this.http.post<any>(url, req, tokenOption);
  }
  GetBranchDetailsByEmpId(LOGIN_ID) {
    ////////
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(sessionStorage.getItem('m5JkoXISmYRAIuY'));
    let User_Type = this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'));
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(token + "@" + UserId + "|" + User_Type + "|" + IpAddress);
    const tokenOption = {
      headers:
        new HttpHeaders(
          {
            'Content-Type': 'application/json',
            'Authorization': `Basic ${TOKEN}`,
          })
    }
    let url = `${this.ServerUrl}/api/ReportFilter/EmployeeWiseDetails`;
    console.log("clientid url " + url + "     :::  " + `EMPLOYEE_CODE=${LOGIN_ID}`)
    const QueryString = `EMPLOYEE_CODE=${LOGIN_ID}`;
    const body = this.ConvertToJSON.QueryStringToJSON(QueryString);
    return this.http.post<any>(url, body, tokenOption);
  }
  getCllientByPan(LOGIN_ID, UserType, Trans_Type, PanNo) {
    ////////
    console.log("Encr Pan " + PanNo);
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(sessionStorage.getItem('m5JkoXISmYRAIuY'));
    let User_Type = this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'));
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(token + "@" + UserId + "|" + User_Type + "|" + IpAddress);
    const tokenOption = {
      headers:
        new HttpHeaders(
          {
            'Content-Type': 'application/json',
            'Authorization': `Basic ${TOKEN}`,
          })
    }
    let url = `${this.ServerUrl}/api/ReportFilter/ReportDetails`;
    const QueryString = `TRANS_TYPE=${this.EncrdecrService.setEncr(Trans_Type)}&LOGIN_ID=${this.EncrdecrService.setEncr(LOGIN_ID)}&USER_TYPE=${this.EncrdecrService.setEncr('1')}&PANNo=${PanNo}`;
    const body = this.ConvertToJSON.QueryStringToJSON(QueryString);
    // const body = {
    //   "TRANS_TYPE":Trans_Type,
    //   "LOGIN_ID":LOGIN_ID,
    //   "USER_TYPE":"1",
    //   "PANNo":PanNo
    // };
    let str = JSON.stringify(body);
    console.log(str);
    console.log('URL::: ' + url);
    console.log('token ' + token + "@" + UserId + "|" + User_Type + "|" + IpAddress);
    return this.http.post<any>(url, body, tokenOption);
  }
  BindClientFolio(ClientId, SchemeCode) {
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(sessionStorage.getItem('m5JkoXISmYRAIuY'));
    let User_Type = this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'));
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(token + "@" + UserId + "|" + User_Type + "|" + IpAddress);
    // const tokenOption = {
    //   headers:
    //     new HttpHeaders(
    //       {
    //         'Content-Type': 'application/json',
    //         'Authorization': `Basic ${TOKEN}`,
    //       })
    // }
    const url = `${this.ServerUrl}/api/DropDown/ReportDetails`;
    const QueryString = `TRANS_TYPE=ClientWiseFolio&CON_STR=MF&REFF_ID=${ClientId}&REFF_ID2=${SchemeCode}`;
    // const body = this.ConvertToJSON.QueryStringToJSON(QueryString);
    console.log('Bind Client Folio' + url);
    const tokenOption = this.GetToken();
    const body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(QueryString);
    return this.http.post<any>(url, body, tokenOption).pipe();
    // return this.http.post<any>(url, body, tokenOption);
  }
  GetToken() {
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(sessionStorage.getItem('m5JkoXISmYRAIuY'));
    let User_Type = this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'));
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    console.log('token::  ' + token + "@" + UserId + "|" + User_Type + "|" + IpAddress);
    const TOKEN = btoa(token + "@" + UserId + "|" + User_Type + "|" + IpAddress);
    const tokenOption = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Basic ${TOKEN}`,
      })
    }
    return tokenOption;
  }
  GetFolioMasterData(FolioNumber, SchemeCode, Role_ID, ClientBasicInfoID, UccCode = ""): Observable<any> {
    let DataUrl = `${this.ServerUrl}/api/FolioDetails?FolioNumber=${FolioNumber}&SchemeCode=${SchemeCode}&Role_ID=${Role_ID}&ClientBasicInfoIdList=${ClientBasicInfoID}&UCCCode=${UccCode}`;
    const tokenOption = this.GetToken();
    const url = DataUrl.split('?')[0];
    const QueryString = DataUrl.split('?')[1];
    const body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(QueryString);
    return this.http.post<any>(url, body, tokenOption).pipe();
    // return this.http.get<any>(url, this.GetToken()).pipe();
  }
  PostReportScheduler(formData) {
    let url = `${this.ServerUrl}/api/ReportShedular/Details`;
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(sessionStorage.getItem('m5JkoXISmYRAIuY'));
    let User_Type = this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'));
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(token + "@" + UserId + "|" + User_Type + "|" + IpAddress);
    const tokenOption = {
      headers:
        new HttpHeaders(
          {
            'Content-Type': 'application/json',
            'Authorization': `Basic ${TOKEN}`,
          })
    }

    return this.http.post<any>(url, formData, tokenOption)
  }
  getNSESTPSWPOrderBook(FromDate, EndDate, ClientBasicInfoId, ApplicationId, PWD, Broker_code, UniqueNo, TYPE) {

    // tslint:disable-next-line: max-line-length
    const url = `${this.ServerUrl}/api/NSEReport/GetSTPSWPOrderDetails?FromDate=${FromDate}&EndDate=${EndDate}&CUSTOMER_ID=${ClientBasicInfoId}&APPLN_ID=${ApplicationId}&PWD=${PWD}&BROKER_CODE=${Broker_code}&unique_no=${UniqueNo}&TYPE=${TYPE}`;
    console.log('nse order book data' + url)
    return this.http.get<any>(url, this.GetToken());
  }

  GetSSRSReport(EmpCode) {
    let url = `${this.ServerUrl}/api/SSRS/Details`;
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(sessionStorage.getItem('m5JkoXISmYRAIuY'));
    let User_Type = this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'));
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(token + "@" + UserId + "|" + User_Type + "|" + IpAddress);
    const tokenOption = {
      headers:
        new HttpHeaders(
          {
            'Content-Type': 'application/json',
            'Authorization': `Basic ${TOKEN}`,
          })
    }
    let request = {
      'EmployeeCode': EmpCode
    }

    return this.http.post<any>(url, request, tokenOption)
  }
  getRMTaggingReport(FromDate, EndDate) {
    //this.ServerUrl="http://localhost:4094/";
    // tslint:disable-next-line: max-line-length
    const url = `${this.ServerUrl}/api/RMTaggingReport/Details?FromDate=${FromDate}&EndDate=${EndDate}`;
    // console.log('nse order book data' + url)
    return this.http.get<any>(url, this.GetToken());
  }
  getClientdropoffReport(FromDate, EndDate) {
    //this.ServerUrl="http://localhost:4094/";
    // tslint:disable-next-line: max-line-length
    const url = `${this.ServerUrl}/api/RMTaggingReport/DropoffDetails?FromDate=${FromDate}&EndDate=${EndDate}`;
    //console.log('nse order book data' + url)
    return this.http.get<any>(url, this.GetToken());
  }
  getLeadCreationReport(FromDate, EndDate) {

    // tslint:disable-next-line: max-line-length
    const url = `${this.ServerUrl}/api/MahindraUser/Details?FromDate=${FromDate}&EndDate=${EndDate}`;
    // console.log('nse order book data' + url)
    return this.http.get<any>(url, this.GetToken());
  }
  getClientTransactionStatus(ClientId, Flag) {
    let s_url = `${this.ServerUrl}/api/DropDown/ReportDetails?TRANS_TYPE=${Flag}&REFF_ID=${ClientId}&CON_STR=OptiCloud`;
    const tokenOption = this.GetToken();
    const url = s_url.split('?')[0];
    const QueryString = s_url.split('?')[1];
    // const body = this.ConvertToJSON.QueryStringToJSON(QueryString);
    const body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(QueryString);
    return this.http.post<any>(url, body, tokenOption).pipe();
  }
  SendTransactionEmail(body: any) {

    // tslint:disable-next-line: max-line-length
    const url = `${this.ServerUrl}/api/NSEReport/SendTransactionEmail`;
    console.log('nse order book data' + url)
    return this.http.post<any>(url, body, this.GetToken());
  }
  getSubCategoryData(Flag, FundTye) {
    let s_url = `${this.ServerUrl}/api/DropDown/ReportDetails?TRANS_TYPE=${Flag}&REFF_ID=${FundTye}&CON_STR=OptiCloud`;
    const tokenOption = this.GetToken();
    const url = s_url.split('?')[0];
    const QueryString = s_url.split('?')[1];
    // const body = this.ConvertToJSON.QueryStringToJSON(QueryString);
    const body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(QueryString);
    return this.http.post<any>(url, body, tokenOption).pipe();
  }
  async getClientMandateReport(
    ClientEMandateId,
    ClientBasciInfoId,
    MandateId,
    MandateType,
    Flag,
    Role_ID, rid = "", jid = "", UserType = "0", initiatedBy = "",
    FromDate = "",
    ToDate = ""
  ) {
    // tslint:disable-next-line: max-line-length
    const url = `${this.ServerUrl}/api/ClientMandateReport/GetClientMandateReport?ClientBasciInfoId=${ClientBasciInfoId}&MandateId=${MandateId}&MandateType=${MandateType}&Flag=${Flag}&ClientEMandateId=${ClientEMandateId}&Role_ID=${Role_ID}&rid=${rid}&jid=${jid}&UserType=${UserType}&initiatedBy=${initiatedBy}&from_date_NSE=${FromDate}&to_date_NSE=${ToDate}`;
    // console.log('nse order book data' + url)
    const json = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(
      url.split("?")[1]
    );
    // return this.http.post<any>(url.split("?")[0], json, this.GetToken());
    const result = await this.postAPICall(json, "/api/ClientMandateReport/GetClientMandateReport",this.GetToken());
    return result;
  }
  getClientMandateReportNSE(ClientEMandateId, ClientBasciInfoId, MandateId, MandateType, Flag) {

    // tslint:disable-next-line: max-line-length
    const url = `${this.ServerUrl}/api/ClientMandateReport/GetClientMandateReportNSE?ClientBasciInfoId=${ClientBasciInfoId}&MandateId=${MandateId}&MandateType=${MandateType}&Flag=${Flag}&ClientEMandateId=${ClientEMandateId}`;
    // console.log('nse order book data' + url)
    const json = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(url.split('?')[1]);
    return this.http.post<any>(url.split('?')[0], json, this.GetToken());
  }

  SIPCancellationReport(ClientBasciInfoId, Status, Flag,FromDate,ToDate): Observable<any> {
    //////////
    debugger
    let rid = "";
    if (rid == "" && 
              sessionStorage.getItem('F44sGAGh2xwkpUL') != undefined &&
              sessionStorage.getItem('F44sGAGh2xwkpUL') != null &&
              sessionStorage.getItem('F44sGAGh2xwkpUL') != ""
            ) {
              let date = new Date();
              rid = date.getFullYear().toString() + date.getMonth().toString() + date.getDate().toString() + date.getHours().toString() + date.getMinutes().toString() + date.getSeconds().toString() + date.getMilliseconds().toString() + this.EncrdecrService.getDecr(sessionStorage.getItem("F44sGAGh2xwkpUL"));
            }
    
        let jid = "";
        let userType = 0;
        let initiatedBy = "";
    
        if (sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX') != undefined &&
            sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX') != null &&
            sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX') != "") {
              jid = this.EncrdecrService.setEncr(sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX'));
            }
    
            if (sessionStorage.getItem('L2D3506kIHSk3E0') != undefined &&
            sessionStorage.getItem('L2D3506kIHSk3E0') != null &&
            sessionStorage.getItem('L2D3506kIHSk3E0') != "") {
              userType = +this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'))
            }
    
            if (sessionStorage.getItem("F44sGAGh2xwkpUL") != undefined &&
            sessionStorage.getItem("F44sGAGh2xwkpUL") != null &&
            sessionStorage.getItem("F44sGAGh2xwkpUL") != "") {
              initiatedBy = this.EncrdecrService.getDecr(sessionStorage.getItem("F44sGAGh2xwkpUL"))
            }

    let s_url = `${this.ServerUrl}/api/XisipSipRegReport/GetXisipSipRegReport?ClientBasicInfoIdList=${ClientBasciInfoId}&Status=${Status}&Flag=${Flag}&rid=${rid}&jid=${jid}&UserType=${userType}&initiatedBy=${initiatedBy}&from_date_NSE=${FromDate}&to_date_NSE=${ToDate}`;
    const tokenOption = this.GetToken();
    const url = s_url.split('?')[0];
    const QueryString = s_url.split('?')[1];
    const body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(QueryString);
    return this.http.post<any>(url, body, tokenOption).pipe();
  }

  InsertClientXsipPendingTransfection(formData): Observable<any> {
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(sessionStorage.getItem('m5JkoXISmYRAIuY'));
    let UserType = this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'));
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(token + "@" + UserId + "|" + UserType + "|" + IpAddress);
    const tokenOption = {
      headers:
        new HttpHeaders(
          {
            'Content-Type': 'application/json',
            'Authorization': `Basic ${TOKEN}`,
          })
    }
    const url = `${this.ServerUrl}/api/XisipSipRegReport/InsertClientXsipPendingTransfection`;
    return this.http.post<any>(url, formData, tokenOption);

  }

  CheckVersion(): Observable<any> {
    const url = `${this.ServerUrl}/api/Version/Detail`;
    return this.http.get<any>(url, headers);

  }

  GetClientFDTransactionReport(data: any) {
    // let s_url =
    //   `http://localhost:2010/` + `api/FDTransaction/GetFDTransactionDetails`;
    // const tokenOption = this.GetToken();
    // const body = { data: this.EncrdecrService.setEncr(data) };
    // return this.http.post<any>(s_url, body, tokenOption).pipe();
    // // return this.http.post<any>(s_url, data, tokenOption).pipe();

    const tokenOption = this.GetToken();
    const url =`${this.ServerUrl}/api/FDTransaction/GetFDTransactionDetails`;

    const body = { data: this.EncrdecrService.setEncr(data) };

    // return this.http.post<any>(url, {}, this.GetToken()).pipe();
    return this.http.post(url, body, {
      ...tokenOption,
      responseType: 'blob' as 'json'
    });

  }

  getAOFReport(Flag, PANNo, USER_ID, LoginMode, ClientID, UccCode, SubBrokerID, Date, Role_ID, UserType) {

    // tslint:disable-next-line: max-line-length
    const DataUrl = `${this.ServerUrl}/api/AOFReport/Details?Flag=${Flag}&PANNo=${PANNo}&USER_ID=${USER_ID}&LoginMode=${LoginMode}&ClientID=${ClientID}&UccCode=${UccCode}&SubBrokerID=${SubBrokerID}&Date=${Date}&Role_ID=${Role_ID}&UserType=${UserType}`;
    // console.log('nse order book data' + url)
    const tokenOption = this.GetToken();
    const url = DataUrl.split('?')[0];
    const QueryString = DataUrl.split('?')[1];
    const body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(QueryString);
    return this.http.post<any>(url, body, tokenOption).pipe();

    // return this.http.get<any>(url, this.GetToken());
  }
  GET_CapitalGainReport_JM(USER_TYPE, ClientBasicInfoIdList, FromDate, EndDate, GrandFather, FinancialYear, Employee, subBrokerId, Role_ID, LogInUserID_Code, CurrentHolding): Observable<any> {
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(sessionStorage.getItem('m5JkoXISmYRAIuY'));
    let User_Type = this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'));
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(token + "@" + UserId + "|" + User_Type + "|" + IpAddress);
    // const tokenOption = {
    //   headers:
    //     new HttpHeaders(
    //       {
    //         'Content-Type': 'application/json',
    //         'Authorization': `Basic ${TOKEN}`,
    //       })
    // }
    // Employee = 0;
    if (USER_TYPE == 3) { subBrokerId = "0" }
    debugger
    let url = `${this.ServerUrl}/api/CapitalGainWithAndWithoutIndexsation/Details_JM`;
    const QueryString = `TRANS_TYPE=CLIENT_ID&Employee=${Employee}&SubBroker=${subBrokerId}&USER_TYPE=${USER_TYPE}&ClientBasicInfoIdList=${ClientBasicInfoIdList}&FromDate=${FromDate}&EndDate=${EndDate}&GrandFather=${GrandFather}&FinancialYear=${FinancialYear}&select_type=true&LogInUserID_Code=${LogInUserID_Code}&CurrentHolding=${CurrentHolding}&Role_ID=${Role_ID}`;
    // const body = this.ConvertToJSON.QueryStringToJSON(QueryString);
    //console.log('WI='+url)
    const tokenOption = this.GetToken();
    const body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(QueryString);
    console.log(JSON.stringify(body))
    console.log("Capital Gain Report With Indexion")
    console.log(url)
    console.log(token + "@" + UserId + "|" + User_Type + "|" + IpAddress)
    // url = url + '?' + QueryString;
    return this.http.post<any>(url, body, tokenOption).pipe();
    // return this.http.post<any>(url, body, tokenOption);
  }

  GetClientWiseAUMReport(data: any) {
    let s_url = environment.ServerUrl + `/api/ClientWiseAUM/GetReport`;
    const tokenOption = this.GetToken();
    let req_str = JSON.stringify(data);
    const body = { data: this.EncrdecrService.setEncr(req_str) };
    return this.http.post<any>(s_url, body, tokenOption).pipe();
    // return this.http.post<any>(s_url, data, tokenOption).pipe();
  }

  GetClientWiseMobReport(data: any) {
    let s_url = environment.ServerUrl + `/api/MobilizationReport/GetClientWiseMobReport`;
    const tokenOption = this.GetToken();
    let req_str = JSON.stringify(data);
    const body = { data: this.EncrdecrService.setEncr(req_str) };
    return this.http.post<any>(s_url, body, tokenOption).pipe();
    // return this.http.post<any>(s_url, data, tokenOption).pipe();
  }

  GetBusinessWiseMobReport(data: any) {
    let s_url = environment.ServerUrl + `/api/MobilizationReport/GetBusinessWiseMobReport`;
    const tokenOption = this.GetToken();
    let req_str = JSON.stringify(data);
    const body = { data: this.EncrdecrService.setEncr(req_str) };
    return this.http.post<any>(s_url, body, tokenOption).pipe();
    // return this.http.post<any>(s_url, data, tokenOption).pipe();
  }
  GetTopMostDataReport(data: any) {
    let s_url = environment.ServerUrl + `/api/CLientDashboard/GetDashboardTopMostDataReport`;
    let req_str = JSON.stringify(data);
    const body = { data: this.EncrdecrService.setEncr(req_str) };
    return this.http.post<any>(s_url, body, this.GetToken()).pipe();
  }
  GetNetSellDataReport(data: any) {
    let s_url = environment.ServerUrl + `/api/NetSales/GetNetSalesReport`;
    const tokenOption = this.GetToken();
    let req_str = JSON.stringify(data);
    const body = { data: this.EncrdecrService.setEncr(req_str) };
    return this.http.post<any>(s_url, body, tokenOption).pipe();
    // return this.http.post<any>(s_url, data, this.GetToken()).pipe();
  }
  GetClientCountReport(data: any) {
    let s_url = environment.ServerUrl + `/api/ClientCount/GetClientCount`;
    return this.http.post<any>(s_url, data, this.GetToken()).pipe();
  }
  // Added by Yaksh
  GetStopSIPClientCountReport(data: any) {
    let s_url = environment.ServerUrl + `/api/ClientCountStopSIP/Details`;
    return this.http.post<any>(s_url, data, this.GetToken()).pipe();
  }
  GetBusinessMetricReport(data: any) {
    let s_url = environment.ServerUrl + `/api/IFDWiseMobilization/GetIFDWiseMobilization`;
    const tokenOption = this.GetToken();
    let req_str = JSON.stringify(data);
    const body = { data: this.EncrdecrService.setEncr(req_str) };
    return this.http.post<any>(s_url, body, tokenOption).pipe();

    // return this.http.post<any>(s_url, data, this.GetToken()).pipe();
  }
  GetActNowCaptionList(uid, ut) {
    let url = `${this.ServerUrl}/api/DropDown/GetDetails?TRANS_TYPE=ActNowCaption&REFF_ID=${uid}&CON_STR=CLOUD&REFF_ID2=${ut}&REFF_ID3=`;
    let body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(url.split('?')[1]);
    return this.http.post<any>(url.split('?')[0], body, this.GetToken());
  }
  GetActNowCaptionDescription(uid, caption, transtype = 'RemarkBasedActNowCaption', UserType) {
    let url = `${this.ServerUrl}/api/DropDown/GetDetails?TRANS_TYPE=${transtype}&REFF_ID=${uid}&CON_STR=CLOUD&REFF_ID2=${UserType}&REFF_ID3=${caption}`;
    let body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(url.split('?')[1]);
    return this.http.post<any>(url.split('?')[0], body, this.GetToken());
  }
  GetDetailsBySchemeCode(Scheme_Code, exchange, transtype = 'ExchangeSchemeCode_Optcode') {
    let url = `${this.ServerUrl}/api/DropDown/GetDetails?TRANS_TYPE=${transtype}&REFF_ID=${Scheme_Code}&CON_STR=CLOUD&REFF_ID2=${exchange}&REFF_ID3=`;
    let body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(url.split('?')[1]);
    return this.http.post<any>(url.split('?')[0], body, this.GetToken());
  }
  ConvertToPDF(data: any) {
    let s_url = `https://selectpdf.com/api2/convert/`;
    return this.http.post<any>(s_url, data, headers).pipe();
  }

  GetIFDDetails(data: any) {
    let s_url = environment.ServerUrl + `/api/RMDashboard/GetRMIFDsDetails`;
    const request = { data: this.EncrdecrService.setEncr(data) }
    return this.http.post<any>(s_url, request, this.GetToken()).pipe();
  }
  GetHoldingTransactionWise(data): Observable<any> {
    let url = `${this.ServerUrl}/api/HoldingTransactionWise/GetHoldingTransactionWise`;
    const tokenOption = this.GetToken();
    let req_str = JSON.stringify(data);
    const body = { data: this.EncrdecrService.setEncr(req_str) };
    return this.http.post<any>(url, body, tokenOption).pipe();

    // return this.http.post<any>(url, body, this.GetToken());
  }

  GetOpeningClosingReport(data: any) {
    let s_url = environment.ServerUrl + `/api/OpeningClosing/GetReport`;
    const tokenOption = this.GetToken();
    let req_str = JSON.stringify(data);
    const body = { data: this.EncrdecrService.setEncr(req_str) };
    return this.http.post<any>(s_url, body, tokenOption).pipe();
  }

  GetInsuranceTransactionReport(data): Observable<any> {
    let url = `${this.ServerUrl}/api/InsuranceReport/GetInsuranceReport`;
    const tokenOption = this.GetToken();
    let req_str = JSON.stringify(data);
    // const body = { data: this.EncrdecrService.setEncr(req_str) };
    return this.http.post<any>(url, data, tokenOption).pipe();
    // return this.http.post<any>(url, body, this.GetToken());
  }
  FetchToken() {
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(sessionStorage.getItem('m5JkoXISmYRAIuY'));
    let User_Type = this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'));
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    console.log('token::  ' + token + "@" + UserId + "|" + User_Type + "|" + IpAddress);
    const TOKEN = btoa(token + "@" + UserId + "|" + User_Type + "|" + IpAddress);
    return TOKEN;
  }
  GETSOADOCS(data: any) {
    let s_url = environment.ServerUrl + `/api/SOA/Details`;
    //let s_url = `http://localhost:2897/api/SOA/Details`;
    return this.http.post<any>(s_url, data, this.GetToken()).pipe();
  }
  GETFACTSHEETDATA(data: any) {
    let s_url = environment.ServerUrl + `/api/BSESchemeList/GetBseSchemeDetails`;
    //let s_url = `http://localhost:2897/api/BSESchemeList/GetBseSchemeDetails`;
    return this.http.post<any>(s_url, data, this.GetToken()).pipe();
  }
  SchedulePortFolioService(data: any) {
    let s_url = environment.ServerUrl + `/api/SchedulePortFolio/Details`;
    //let s_url = `http://localhost:2897/api/SchedulePortFolio/Details`;
    return this.http.post<any>(s_url, data, this.GetToken()).pipe();
  }
  getSIPCancellationRemarks(data: any) {
    let s_url = environment.ServerUrl + `/api/BSETransaction/GetSIPCancellationReasons`;
    //let s_url = `http://localhost:2897/api/BSETransaction/GetSIPCancellationReasons`;
    return this.http.post<any>(s_url, data, this.GetToken()).pipe();
  }
  // Added by Yaksh
  getInvestSummary(data: any) {
    let s_url = environment.ServerUrl + `/api/NewInvestSum/Details`;
    //let s_url = `http://localhost:2897/api/NewInvestSum/Details`;
    return this.http.post<any>(s_url, data, this.GetToken()).pipe();
  }
  // Added by Yaksh
  SendPortFolioClient(data: any) {
    let s_url = environment.ServerUrl + `/api/SchedulerPortfolioSendMail/Details`;
    //let s_url = `http://localhost:2897/api/SchedulerPortfolioSendMail/Details`;
    return this.http.post<any>(s_url, data, this.GetToken()).pipe();
  }
  // Added by Yaksh
  GetIFDEarningReports(data: any) {
    let s_url = environment.ServerUrl + `/api/EarningSummary/GetEarningSummaryReport`;
    //let s_url = `http://localhost:2897/api/EarningSummary/GetEarningSummaryReport`;
    const tokenOption = this.GetToken();
    let req_str = JSON.stringify(data);
    const body = { data: this.EncrdecrService.setEncr(req_str) };
    return this.http.post<any>(s_url, body, tokenOption).pipe();
  }
  // Added by Yaksh
  GetIFDEarningReportsDetailed(data: any) {
    let s_url = environment.ServerUrl + `/api/EarningReportDetailed/GetEarningReportDetailed`;
    //let s_url = `http://localhost:2897/api/EarningReportDetailed/GetEarningReportDetailed`;
    const tokenOption = this.GetToken();
    let req_str = JSON.stringify(data);
    const body = { data: this.EncrdecrService.setEncr(req_str) };
    return this.http.post<any>(s_url, body, tokenOption).pipe();
  }
  // Added by Yaksh
  PANSearchClient(data: any) {
    let s_url = environment.ServerUrl + `/api/PANSearchClient/Details`;
    //let s_url = `http://localhost:2897/api/PANSearchClient/Details`;
    return this.http.post<any>(s_url, data, this.GetToken()).pipe();
  }
  // Added by Yaksh
  SubbrokerEmpdetails(data: any) {
    let s_url = environment.ServerUrl + `/api/PANSearchClient/SubbrokerEmpdetails`;
    //let s_url = `http://localhost:2897/api/PANSearchClient/SubbrokerEmpdetails`;
    return this.http.post<any>(s_url, data, this.GetToken()).pipe();
  }

  GeneratePDFFomBase64(formData): Observable<any> {

    let url = `${this.ServerUrl}/api/PDF/GeneratePDFFomBase64`;
    let request = { data: this.EncrdecrService.setEncr(JSON.stringify(formData)) }
    return this.http.post<any>(url, request, this.GetToken()).pipe();
  }
  // Added by Yaksh
  CRMDetails(data: any) {
    let s_url = environment.ServerUrl + `/api/CRM/Details`;
    //let s_url = `http://localhost:2897/api/CRM/Details`;
    return this.http.post<any>(s_url, data, this.GetToken()).pipe();
  }
  GetTokenNonJSON() {
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(sessionStorage.getItem('m5JkoXISmYRAIuY'));
    let User_Type = this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'));
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    console.log(token + "@" + UserId + "|" + User_Type + "|" + IpAddress);
    const TOKEN = btoa(token + "@" + UserId + "|" + User_Type + "|" + IpAddress);
    const tokenOption = {
      headers: new HttpHeaders({
        //'Content-Type': 'application/json',
        'Authorization': `Basic ${TOKEN}`,
      })
    }
    return tokenOption;
  }
  // Added by Yaksh
  CRMSaveAttachment(formData: any) {
    let s_url = environment.ServerUrl + `/api/CRM/SaveAttachment`;
    //let s_url = `http://localhost:2897/api/CRM/SaveAttachment`;
    return this.http.post<any>(s_url, formData, this.GetTokenNonJSON());
  }
  //Added By Dharmesh
  GetNetSaleForDashBoard(data: any) {
    let s_url = environment.ServerUrl + `/api/NetSaleData/GetNetSaleDashboardData`;
    const tokenOption = this.GetToken();
    let req_str = JSON.stringify(data);
    const body = { data: this.EncrdecrService.setEncr(req_str) };
    return this.http.post<any>(s_url, body, tokenOption).pipe();
    // return this.http.post<any>(s_url, data, this.GetToken()).pipe();
  }

  GetClientTransactionData(data: any) {
    let s_url = environment.ServerUrl + `/api/ClientTransactionController/GetClientTransactionData`;
    const tokenOption = this.GetToken();
    let req_str = JSON.stringify(data);
    const body = { data: this.EncrdecrService.setEncr(req_str) };
    return this.http.post<any>(s_url, body, tokenOption).pipe();
    // return this.http.post<any>(s_url, data, this.GetToken()).pipe();
  }
  //Added by tishya for binding mandates which are approved
  getClientMandatelist_OTMPayment(
    ClientEMandateId,
    ClientBasciInfoId,
    MandateId,
    MandateType,
    Flag,
    Role_ID, rid = "", jid = "", UserType = "0", initiatedBy = ""
  ) {
    debugger;
    // tslint:disable-next-line: max-line-length
    const url = `${this.ServerUrl}/api/ClientMandateReport/ClientMandatelist_OTMPayment?ClientBasciInfoId=${ClientBasciInfoId}&MandateId=${MandateId}&MandateType=${MandateType}&Flag=${Flag}&ClientEMandateId=${ClientEMandateId}&Role_ID=${Role_ID}&rid=${rid}&jid=${jid}&UserType=${UserType}&initiatedBy=${initiatedBy}`;
    console.log("URL" + url);
    const json = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(
      url.split("?")[1]
    );
    return this.http.post<any>(url.split("?")[0], json, this.GetToken());
  }
  GetPDFData(data: any, URL: string): Observable<any> {
    let url = URL;
    const tokenOption = this.GetToken();
    // let req_str = JSON.stringify(data);
    const body = { data: data };
    return this.http.post<any>(url, body, tokenOption).pipe();
    // return this.http.post<any>(url, data, this.GetToken());
  }
  GetFamilyPortfolioReport(data): Observable<any> {
    let url = `${this.ServerUrl}/api/FamilyPortfolio/FamilyPortfolioReport`;
    const tokenOption = this.GetToken();
    let req_str = JSON.stringify(data);
    const body = { data: this.EncrdecrService.setEncr(req_str) };
    return this.http.post<any>(url, body, tokenOption).pipe();
    // return this.http.post<any>(url, body, this.GetToken());
  }

  GetFamilyPortfolioSummary(data): Observable<any> {
    let url = `${this.ServerUrl}/api/FamilyPortfolio/FamilyPortfolioSummary`;
    const tokenOption = this.GetToken();
    let req_str = JSON.stringify(data);
    const body = { data: this.EncrdecrService.setEncr(req_str) };
    return this.http.post<any>(url, body, tokenOption).pipe();
    // return this.http.post<any>(url, body, this.GetToken());
  }

  //Added By Devang Mehta On 13-02-2025
  async getClientMandateReportForApproval(UCCode, FromDate = "",ToDate = "") {
    const url = `/api/ClientMandate/GetMandateForApproval_POST`;
    const QueryString = `UCCCode=${UCCode}&from_date_NSE=${FromDate}&to_date_NSE=${ToDate}`;
    const body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(QueryString);
    // return this.http.get<any>(url, this.GetToken());
    const result = await this.postAPICall(body, url,this.GetToken());
    return result;
  }
  //End By Devang Mehta

  //aditya
  PostDetailedBrok(MonthYear = "", Subbrokercode = "", UTRNUM = "0"): Observable<any> {

    const url = (UTRNUM === "0")

      ? `${this.ServerUrl}/api/MFBrokerage/GetSummaryBrokerage?MonthYear=${this.EncrdecrService.setEncr(MonthYear)}&Subbrokercode=${Subbrokercode}`
      :
      `${this.ServerUrl}/api/MFBrokerage/GetDetailedBrokerage?MonthYear=${this.EncrdecrService.setEncr(MonthYear)}&Subbrokercode=${Subbrokercode}&UTRNumber=${this.EncrdecrService.setEncr(UTRNUM)}`;

    return this.http.post<any>(url, {}, this.GetToken()).pipe();
  } 

  GetActiveRegisterSIPReport(data): Observable<any> {
    let url = `${this.ServerUrl}/api/MISActiveRegisterSIPController/getSIPReport`;
    const tokenOption = this.GetToken();
    let req_str = JSON.stringify(data);
    const body = { data: this.EncrdecrService.setEncr(req_str) };
    return this.http.post<any>(url, body, tokenOption).pipe();
    // return this.http.post<any>(url, body, this.GetToken());
  }
 
  //added by Riya 
  GetClientWiseAUMReportNew(data: any) {
    debugger;
    let s_url = environment.ServerUrl + `/api/ClientWiseAUM/GetReportNew`;
    const tokenOption = this.GetToken();
    let req_str = JSON.stringify(data);
    const body = { data: this.EncrdecrService.setEncr(req_str) };
    return this.http.post<any>(s_url, body, tokenOption).pipe();
    // return this.http.post<any>(s_url, data, tokenOption).pipe();
  }

  GetOverAllReport(input: any) {
    let Url = this.ServerUrl + '/api/OverAllNetSell'
    let EncrptedInput = this.EncrdecrService.setEncr(JSON.stringify(input))
    return this.http.post<any>(Url, { "data": EncrptedInput }, this.GetToken()).pipe();
  }

  GetClientWiseAUMReportData(data: any): Observable<any> {
    debugger
    let url = environment.ServerUrl + `/api/ClientWiseAUM/GetReportData`;
    const tokenOption = this.GetToken();
    const reqStr = JSON.stringify(data);
    const body = { data: this.EncrdecrService.setEncr(reqStr) };
  
    // IMPORTANT: Specify responseType: 'blob'
    return this.http.post(url, body, {
      ...tokenOption,
      responseType: 'blob' as 'json'
    });
  }

  GetPortfolioSummaryReportForClient(data): Observable<any> {
    let url = `${this.ServerUrl}/api/PortfolioSummary/SummaryForClient`;
    const tokenOption = this.GetToken();
    let req_str = JSON.stringify(data);
    const body = { data: this.EncrdecrService.setEncr(req_str) };
    return this.http.post<any>(url, body, tokenOption).pipe();
    // return this.http.post<any>(url, body, this.GetToken());
  }

  GetYearAndMonth(Flag) {
    const url = `${this.ServerUrl}/api/MFBrokerage/GetYearAndMonth?Flag=${Flag}`;
    return this.http.get<any>(url, this.GetToken());
  }

  PostDetailedBrokNew(
    MonthYear = "",
    Subbrokercode = "",
    UTRNUM = "0",
    MAName = "",
    MACode = ""
  ): Observable<any> {
    
    const tokenOption = this.GetToken();
    const body = {};
    const url =
      UTRNUM === "0"
        ? `${this.ServerUrl
        }/api/MFBrokerage/GetSummaryBrokerage?MonthYear=${this.EncrdecrService.setEncr(
          MonthYear
        )}&Subbrokercode=${Subbrokercode}`
        : `${this.ServerUrl
        }/api/MFBrokerage/GetDetailedBrokerageNew?MonthYear=${this.EncrdecrService.setEncr(
          MonthYear
        )}&Subbrokercode=${Subbrokercode}&UTRNumber=${this.EncrdecrService.setEncr(
          UTRNUM
        )}&MAName=${this.EncrdecrService.setEncr(MAName)}&MACode=${this.EncrdecrService.setEncr(MACode)}`;

    // return this.http.post<any>(url, {}, this.GetToken()).pipe();
    return this.http.post(url, body , {
      ...tokenOption,
      responseType: 'blob' as 'json'
    });
  }

  GetPortfolioSummaryReportRealised(data): Observable<any> {
    let url = `${this.ServerUrl}/api/PortfolioSummary/SummaryRealised`;
    const tokenOption = this.GetToken();
    let req_str = JSON.stringify(data);
    const body = { data: this.EncrdecrService.setEncr(req_str) };
    return this.http.post<any>(url, body, tokenOption).pipe();
    // return this.http.post<any>(url, body, this.GetToken());
  }

  GetPortfolioComprehensiveReportRealised(data): Observable<any> {
    let url = `${this.ServerUrl}/api/PortfolioComprehensive/ComprehensiveRealised`;
    const tokenOption = this.GetToken();
    let req_str = JSON.stringify(data);

    let rid = "";
    if (rid == "" && 
              sessionStorage.getItem('F44sGAGh2xwkpUL') != undefined &&
              sessionStorage.getItem('F44sGAGh2xwkpUL') != null &&
              sessionStorage.getItem('F44sGAGh2xwkpUL') != ""
            ) {
              let date = new Date();
              rid = date.getFullYear().toString() + date.getMonth().toString() + date.getDate().toString() + date.getHours().toString() + date.getMinutes().toString() + date.getSeconds().toString() + date.getMilliseconds().toString() + this.EncrdecrService.getDecr(sessionStorage.getItem("F44sGAGh2xwkpUL"));
            }
    
        let jid = "";
        let userType = 0;
        let initiatedBy = "";
    
        if (sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX') != undefined &&
            sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX') != null &&
            sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX') != "") {
              jid = this.EncrdecrService.setEncr(sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX'));
            }
    
            if (sessionStorage.getItem('L2D3506kIHSk3E0') != undefined &&
            sessionStorage.getItem('L2D3506kIHSk3E0') != null &&
            sessionStorage.getItem('L2D3506kIHSk3E0') != "") {
              userType = +this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'))
            }
    
            if (sessionStorage.getItem("F44sGAGh2xwkpUL") != undefined &&
            sessionStorage.getItem("F44sGAGh2xwkpUL") != null &&
            sessionStorage.getItem("F44sGAGh2xwkpUL") != "") {
              initiatedBy = this.EncrdecrService.getDecr(sessionStorage.getItem("F44sGAGh2xwkpUL"))
            }

    const body = { data: this.EncrdecrService.setEncr(req_str),
      rid: rid,
      jid: jid,
      userType: userType,
      initiatedBy: initiatedBy  };
      
    return this.http.post<any>(url, body, tokenOption).pipe();

    // return this.http.post<any>(url, body, this.GetToken());
  }


//Added by tishya
GetDividendReportDetails(data: any):Observable<any> {
  let url = `${this.ServerUrl}/api/Dividend/ReportDetails`;
  const tokenOption = this.GetToken();
  let req_str = JSON.stringify(data);
  const body = { data: this.EncrdecrService.setEncr(req_str) };
  return this.http.post<any>(url, body, tokenOption).pipe();
}

//Ended by Tishya 

  //Added for IIFL - 253,254 started
  GetTransactionReport_MIS(input: any) {
    let Url = this.ServerUrl + "/api/OverAllNetSell/GetTransactionReportMIS";
    let EncrptedInput = this.EncrdecrService.setEncr(JSON.stringify(input));
    return this.http.post<any>(Url, { data: EncrptedInput }, this.GetToken()).pipe();
  }

  GetOrderBookReport_MIS(input: any) {
    let Url = this.ServerUrl + "/api/OverAllNetSell/GetOrderBookReport_MIS";
    let EncrptedInput = this.EncrdecrService.setEncr(JSON.stringify(input));
    return this.http.post<any>(Url, { data: EncrptedInput }, this.GetToken()).pipe();
  }
  //End for IIFL - 254
   //Added for lead details delete - 05082025
   DeleteLeadDetails(data: any): Observable<any> {
    let url = `${this.ServerUrl}/api/AOFReport/DeleteLeadDetails`;
    const tokenOption = this.GetToken();
    let req_str = JSON.stringify(data);
    const body = { data: this.EncrdecrService.setEncr(req_str) };
    return this.http.post<any>(url, body, tokenOption).pipe();
  }
  GetDpHoldingRepert(data): Observable<any> {
    let url = `${this.ServerUrl}/api/DpHolding/Details`;
    const tokenOption = this.GetToken();
    let req_str = JSON.stringify(data);
    const body = { data: this.EncrdecrService.setEncr(req_str) };
    return this.http.post<any>(url, body, tokenOption).pipe();

  }
GetSIPDueReport(data: any): Observable<any> {
  let url = `${this.ServerUrl}/api/DueSipReport/Details`;
  const tokenOption = this.GetToken();
  let req_str = JSON.stringify(data);
  const body = { data: this.EncrdecrService.setEncr(req_str) };
  return this.http.post<any>(url, body, tokenOption).pipe();
  // return this.http.post<any>(url, data, this.GetToken());
}

  GetPageTypeListDetails(data): Observable<any> {
    let url = `${this.ServerUrl}/api/DeepLink/GetPageTypeList`;
    const tokenOption = this.GetToken();
    let req_str = JSON.stringify(data);
    const body = { data: this.EncrdecrService.setEncr(req_str) };
    return this.http.post<any>(url, body, tokenOption).pipe();
  }
  
  getFieldsForPage(data: any): Observable<any> {
    const url = `${this.ServerUrl}/api/DeepLink/GetFields`;
    const tokenOption = this.GetToken();
    const req_str = JSON.stringify(data);
    const body = { data: this.EncrdecrService.setEncr(req_str) };
    return this.http.post<any>(url, body, tokenOption).pipe();
  }
  
  InsertGetDeeplink(payload: any): Observable<any> {
    const url = `${this.ServerUrl}/api/DeepLink/InsertGetDeeplink`;
    const tokenOption = this.GetToken();
    const req_str = JSON.stringify(payload);
    const body = { data: this.EncrdecrService.setEncr(req_str) };
    return this.http.post<any>(url, body, tokenOption).pipe();
  }

  getDropdownOptions(data: any): Observable<any> {
    const url = `${this.ServerUrl}/api/DeepLink/GetDropdownOptions`;
    const tokenOption = this.GetToken();
    const req_str = JSON.stringify(data);
    const body = { data: this.EncrdecrService.setEncr(req_str) };
    return this.http.post<any>(url, body, tokenOption).pipe();
  }  

  async getDeepLinkLoginTypes() {
    let s_url = `${this.ServerUrl}/api/DropDown/Details?TRANS_TYPE=GetDeeplinkLogintype&REFF_ID=&REFF_ID2=&REFF_ID3=`;
    const url = s_url.split("?")[0];
    const QueryString = s_url.split("?")[1];
    const body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(QueryString);
    // return this.http.post<any>(url, body).pipe();
    const result = await this.postAPICall(body, "/api/DropDown/Details",{});
    return result;
  }

  async allowtokencheck() {
    let s_url = `${this.ServerUrl}/api/DropDown/Details?TRANS_TYPE=AllowTokenCheck&REFF_ID=&REFF_ID2=&REFF_ID3=`;
    const url = s_url.split("?")[0];
    const QueryString = s_url.split("?")[1];
    const body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(QueryString);
    // return this.http.post<any>(url, body).pipe();
    const result = await this.postAPICall(body, "/api/DropDown/Details",{});
    return result;
  }

  gettokenvalidation(data: any): Observable<any> {
    const url = `${this.ServerUrl}/api/DeepLink/CheckTokenActive`;
    const tokenOption = this.GetToken();
    const req_str = JSON.stringify(data);
    const body = { data: this.EncrdecrService.setEncr(req_str) };
    return this.http.post<any>(url, body, tokenOption).pipe();
  }  

  GetSTPSWPReport(ClientBasciInfoId, Status, Flag,FromDate,ToDate, ReportType): Observable<any> {
    // let url = `${this.ServerUrl}api/STPReport/STPSWPDetails`;
    let rid = "";
    if (rid == "" && 
              sessionStorage.getItem('F44sGAGh2xwkpUL') != undefined &&
              sessionStorage.getItem('F44sGAGh2xwkpUL') != null &&
              sessionStorage.getItem('F44sGAGh2xwkpUL') != ""
            ) {
              let date = new Date();
              rid = date.getFullYear().toString() + date.getMonth().toString() + date.getDate().toString() + date.getHours().toString() + date.getMinutes().toString() + date.getSeconds().toString() + date.getMilliseconds().toString() + this.EncrdecrService.getDecr(sessionStorage.getItem("F44sGAGh2xwkpUL"));
            }
    
        let jid = "";
        let userType = 0;
        let initiatedBy = "";
    
        if (sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX') != undefined &&
            sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX') != null &&
            sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX') != "") {
              jid = this.EncrdecrService.setEncr(sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX'));
            }
    
            if (sessionStorage.getItem('L2D3506kIHSk3E0') != undefined &&
            sessionStorage.getItem('L2D3506kIHSk3E0') != null &&
            sessionStorage.getItem('L2D3506kIHSk3E0') != "") {
              userType = +this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'))
            }
    
            if (sessionStorage.getItem("F44sGAGh2xwkpUL") != undefined &&
            sessionStorage.getItem("F44sGAGh2xwkpUL") != null &&
            sessionStorage.getItem("F44sGAGh2xwkpUL") != "") {
              initiatedBy = this.EncrdecrService.getDecr(sessionStorage.getItem("F44sGAGh2xwkpUL"))
            }

    let s_url = `${this.ServerUrl}/api/XisipSipRegReport/GetSTPSWPRegReport?ClientBasicInfoIdList=${ClientBasciInfoId}&Status=${Status}&Flag=${Flag}&rid=${rid}&jid=${jid}&UserType=${userType}&initiatedBy=${initiatedBy}&from_date_NSE=${FromDate}&to_date_NSE=${ToDate}&ReportType=${ReportType}`;
    // ?TRANS_TYPE=CLIENT_ID&FromDate=${FromDate}&EndDate=${EndDate}&UserType=${UserType}&ClientBasicInfoIdList=${ClientId}&EmployeeCode=${EmployeeId}
    console.log(s_url);
    console.log(ClientBasciInfoId, Status, Flag,FromDate,ToDate);
    // const tokenOption = this.GetToken();
    // const body = { data: this.EncrdecrService.setEncr(formData) };
    // return this.http.post<any>(url, body, tokenOption).pipe();
    const tokenOption = this.GetToken();
    const url = s_url.split('?')[0];
    const QueryString = s_url.split('?')[1];
    const body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(QueryString);
    return this.http.post<any>(url, body, tokenOption).pipe();
  }
  
  GetChallanReport(formData) {
    // let DataUrl = `${this.ServerUrl}/api/OrderBook/OrderBookDetails?UCCCode=${UCCCode}&FromDate=${FromDate}&EndDate=${EndDate}&Flag=${Flag}&Role_ID=${Role_ID}`;
    // console.log("Order book Report URl " + DataUrl);
     const tokenOption = this.GetToken();
    // const url = DataUrl.split('?')[0];
    // const QueryString = DataUrl.split('?')[1];
    // const body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(QueryString);
    // return this.http.post<any>(url, body, tokenOption).pipe();
    // // return this.http.get<any>(url);

    let url = `${this.ServerUrl}/api/OrderBook/OrderBookDetailsForChallan`;

    const body = { data: this.EncrdecrService.setEncr(formData) };
    // return this.http.post<any>(url, formData, this.GetToken());
    return this.http.post<any>(url, body, tokenOption).pipe();
  }

  GetChallanDownloadPDF(formData) {

    const tokenOption = this.GetToken();
    let url = `${this.ServerUrl}/api/ChequeCollectionDeposit/DownloadChallan`;

    // const body = { data: formData };
    // return this.http.post<any>(url, formData, this.GetToken());
    return this.http.post<any>(url, formData, tokenOption).pipe();
  }
  async postAPICall(Request: any, URL: any,headersdy = {}): Promise<any> {
    let Url = `${this.ServerUrl}${URL}`;
    // let Url = `http://localhost:2010/${URL}`;

    let KeyPair = await this.EncrdecrService.getKeyPair();
    Request.publicKey = KeyPair.publicKeySpkiBase64;

    let EncryptedData = await this.EncrdecrService.encryptJson(Request, environment.RSA_PUBLIC_KEY_BASE64);

    let body = {
      "EncryptedData": EncryptedData.encryptedData,
      "dvfv": EncryptedData.encryptedKey,
      "sdcsd": EncryptedData.iv
    };
    if(!headersdy){
      headersdy = headers
    }
    const response = await firstValueFrom(this.http.post<any>(Url, body, headersdy));

    const DecryptedResponse = this.EncrdecrService.decryptResponse(
      response.EncryptedDataBase64,
      response.EncryptedAesKeyBase64,
      response.IvBase64,
      KeyPair.privateKeyPem
    );

    return DecryptedResponse;
  }
  
}
